Sculpteo3DViewerStatic.prototype = new Sculpteo3DViewerCommon();

// Sculpteo3DViewerStatic.prototype.drawLine = function( lineObjectHandle, Ax, Ay, Bx, By, lineImgPath )
// {
/*
 *	LineObjectHandle = an IMG tag with position:absolute
 */

// Var
// xMin        = Math.min( Ax, Bx ),
// yMin        = Math.min( Ay, By ),
// xMax        = Math.max( Ax, Bx ),
// yMax        = Math.max( Ay, By ),
// boxWidth    = Math.max( xMax-xMin, 1 ),
// boxHeight   = Math.max( yMax-yMin, 1 ),
// tmp         = Math.min( boxWidth, boxHeight ),
// smallEdge   = 1,
// newSrc;

// While( tmp>>=1 )
// smallEdge<<=1;

// NewSrc = lineImgPath + smallEdge +( (Bx-Ax)*(By-Ay)<0?"up.gif":"down.gif");
// var currentSrc = lineObjectHandle.attr("src");
// if( !currentSrc || currentSrc.indexOf( newSrc )==-1 ) {
// lineObjectHandle.attr("src", newSrc);
// }

// LineObjectHandle.css({
// width:      boxWidth	+"px",
// height:     boxHeight	+"px",
// left:       xMin		+"px",
// top:        yMin		+"px"
// }).show();
// }

Sculpteo3DViewerStatic.prototype.hideLine = function (lineObjectHandle) {
  lineObjectHandle
    .css({
      width: "0px",
      height: "0px",
      left: "0px",
      top: "0px",
    })
    .hide();
};

/* Line clipping */
Sculpteo3DViewerStatic.prototype.computeOutCode = function (
  x,
  y,
  xmin,
  ymin,
  xmax,
  ymax
) {
  var code = 0;

  if (y > ymax) {
    code |= 8;
  } else if (y < ymin) {
    code |= 4;
  }

  if (x > xmax) {
    code |= 2;
  } else if (x < xmin) {
    code |= 1;
  }

  return code;
};

Sculpteo3DViewerStatic.prototype.clipLine = function (
  x0,
  y0,
  x1,
  y1,
  xmin,
  ymin,
  xmax,
  ymax,
  res
) {
  var tmp;

  /* Cohen-Sutherland line clipping */
  var outcode0 = this.computeOutCode(x0, y0, xmin, ymin, xmax, ymax);
  var outcode1 = this.computeOutCode(x1, y1, xmin, ymin, xmax, ymax);
  var outcodeOut;

  while (true) {
    // Trivial accept
    if (!(outcode0 | outcode1)) {
      res[0] = x0;
      res[1] = y0;
      res[2] = x1;
      res[3] = y1;

      return true;
    }

    // Trivial reject
    if (outcode0 & outcode1) {
      return false;
    }

    var x, y;

    outcodeOut = outcode0 ? outcode0 : outcode1;

    if (outcodeOut & 8) {
      x = x0 + ((x1 - x0) * (ymax - y0)) / (y1 - y0);
      y = ymax;
    } else if (outcodeOut & 4) {
      x = x0 + ((x1 - x0) * (ymin - y0)) / (y1 - y0);
      y = ymin;
    } else if (outcodeOut & 2) {
      y = y0 + ((y1 - y0) * (xmax - x0)) / (x1 - x0);
      x = xmax;
    } else if (outcodeOut & 1) {
      y = y0 + ((y1 - y0) * (xmin - x0)) / (x1 - x0);
      x = xmin;
    }

    if (outcodeOut == outcode0) {
      x0 = x;
      y0 = y;
      outcode0 = this.computeOutCode(x0, y0, xmin, ymin, xmax, ymax);
    } else {
      x1 = x;
      y1 = y;
      outcode1 = this.computeOutCode(x1, y1, xmin, ymin, xmax, ymax);
    }
  }

  return false;
};

Sculpteo3DViewerStatic.prototype.drawCube = function (cube, width, height) {
  var x0, y0, x1, y1, res;

  res = [0, 0, 0, 0];

  /* V0-v1 */
  x0 = cube[2 * 0 + 0];
  y0 = cube[2 * 0 + 1];
  x1 = cube[2 * 1 + 0];
  y1 = cube[2 * 1 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube0", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube0", this.jself));
  }

  /* V1-v2 */
  x0 = cube[2 * 1 + 0];
  y0 = cube[2 * 1 + 1];
  x1 = cube[2 * 2 + 0];
  y1 = cube[2 * 2 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube1", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube1", this.jself));
  }

  /* V2-v3 */
  x0 = cube[2 * 2 + 0];
  y0 = cube[2 * 2 + 1];
  x1 = cube[2 * 3 + 0];
  y1 = cube[2 * 3 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube2", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube2", this.jself));
  }

  /* V3-v0 */
  x0 = cube[2 * 3 + 0];
  y0 = cube[2 * 3 + 1];
  x1 = cube[2 * 0 + 0];
  y1 = cube[2 * 0 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube3", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube3", this.jself));
  }

  /* V4-v5 */
  x0 = cube[2 * 4 + 0];
  y0 = cube[2 * 4 + 1];
  x1 = cube[2 * 5 + 0];
  y1 = cube[2 * 5 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube4", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube4", this.jself));
  }

  /* V5-v6 */
  x0 = cube[2 * 5 + 0];
  y0 = cube[2 * 5 + 1];
  x1 = cube[2 * 6 + 0];
  y1 = cube[2 * 6 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube5", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube5", this.jself));
  }

  /* V6-v7 */
  x0 = cube[2 * 6 + 0];
  y0 = cube[2 * 6 + 1];
  x1 = cube[2 * 7 + 0];
  y1 = cube[2 * 7 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube6", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube6", this.jself));
  }

  /* V7-v4 */
  x0 = cube[2 * 7 + 0];
  y0 = cube[2 * 7 + 1];
  x1 = cube[2 * 4 + 0];
  y1 = cube[2 * 4 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube7", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube7", this.jself));
  }

  /* V0-v4 */
  x0 = cube[2 * 0 + 0];
  y0 = cube[2 * 0 + 1];
  x1 = cube[2 * 4 + 0];
  y1 = cube[2 * 4 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube8", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube8", this.jself));
  }

  /* V1-v5 */
  x0 = cube[2 * 1 + 0];
  y0 = cube[2 * 1 + 1];
  x1 = cube[2 * 5 + 0];
  y1 = cube[2 * 5 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube9", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube9", this.jself));
  }

  /* V2-v6 */
  x0 = cube[2 * 2 + 0];
  y0 = cube[2 * 2 + 1];
  x1 = cube[2 * 6 + 0];
  y1 = cube[2 * 6 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube10", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube10", this.jself));
  }

  /* V3-v7 */
  x0 = cube[2 * 3 + 0];
  y0 = cube[2 * 3 + 1];
  x1 = cube[2 * 7 + 0];
  y1 = cube[2 * 7 + 1];

  if (this.clipLine(x0, y0, x1, y1, 0, 0, width, height, res)) {
    x0 = res[0];
    y0 = res[1];
    x1 = res[2];
    y1 = res[3];
    this.drawLine(
      $(".Sculpteo3DViewerCube11", this.jself),
      x0,
      y0,
      x1,
      y1,
      STATIC_URL + "images/line/"
    );
  } else {
    this.hideLine($(".Sculpteo3DViewerCube11", this.jself));
  }
};

Sculpteo3DViewerStatic.prototype.parseBBox = function () {
  var dx, dy, dz;

  if (this.bbox) {
    dx = this.bbox[3] - this.bbox[0];
    dy = this.bbox[4] - this.bbox[1];
    dz = this.bbox[5] - this.bbox[2];
    var scale = dx;

    if (dy > scale) {
      scale = dy;
    }

    if (dz > scale) {
      scale = dz;
    }

    this.scale = scale;
    this.center_x = (this.bbox[3] + this.bbox[0]) / 2;
    this.center_y = (this.bbox[4] + this.bbox[1]) / 2;
    this.center_z = (this.bbox[5] + this.bbox[2]) / 2;

    var tx = this.center_x;
    var ty = this.center_y;
    var tz = this.center_z;
    var s = Sculpteo3DViewerCommonTransform3D.scale(
      scale * 0.5,
      scale * 0.5,
      scale * 0.5
    );
    var m = Sculpteo3DViewerCommonTransform3D.translation(tx, ty, tz);

    transform = new Sculpteo3DViewerCommonTransform3D();
    transform = transform.x(m);
    transform = transform.x(s);
    this.scene_transform = transform.inverse();

    dx = dx / scale;
    dy = dy / scale;
    dz = dz / scale;

    if (dx < 0.1) {
      dx = 0.1;
    }

    if (dy < 0.1) {
      dy = 0.1;
    }

    if (dz < 0.1) {
      dz = 0.1;
    }
  } else {
    dx = 0.5;
    dy = 0.5;
    dz = 0.5;
  }

  this.cube = new Array();
  this.cube[3 * 0 + 0] = -dx; // 0,0,0
  this.cube[3 * 0 + 1] = -dy;
  this.cube[3 * 0 + 2] = -dz;
  this.cube[3 * 1 + 0] = dx; // 1,0,0
  this.cube[3 * 1 + 1] = -dy;
  this.cube[3 * 1 + 2] = -dz;
  this.cube[3 * 2 + 0] = dx; // 1,1,0
  this.cube[3 * 2 + 1] = dy;
  this.cube[3 * 2 + 2] = -dz;
  this.cube[3 * 3 + 0] = -dx; // 0,1,0
  this.cube[3 * 3 + 1] = dy;
  this.cube[3 * 3 + 2] = -dz;
  this.cube[3 * 4 + 0] = -dx; // 0,0,1
  this.cube[3 * 4 + 1] = -dy;
  this.cube[3 * 4 + 2] = dz;
  this.cube[3 * 5 + 0] = dx; // 1,0,1
  this.cube[3 * 5 + 1] = -dy;
  this.cube[3 * 5 + 2] = dz;
  this.cube[3 * 6 + 0] = dx; // 1,1,1
  this.cube[3 * 6 + 1] = dy;
  this.cube[3 * 6 + 2] = dz;
  this.cube[3 * 7 + 0] = -dx; // 0,1,1
  this.cube[3 * 7 + 1] = dy;
  this.cube[3 * 7 + 2] = dz;
};

// http://devmaster.net/forums/topic/6968-cracks-in-geometry-in-software-rasterizer/
// modified and optimized to draw in a common z and color buffer
Sculpteo3DViewerStatic.prototype.drawTriangleScanLine2 = function (
  zcbuffer,
  canvasWidth,
  canvasHeight,
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  x3,
  y3,
  z3,
  color,
  transparency,
  sval,
  smask
) {
  // Order the vertices [2ms]
  var height, frac;
  var left, bottom;

  var vtx, vty, vtyc, vtz;
  var vbx, vby, vbyc, vbz;
  var vlx, vly, vlyc, vlz;
  var vrx, vry, vryc, vrz;
  var z;

  if (y2 < y1) {
    if (y3 < y2) {
      left = 0;
      vtx = x3;
      vty = y3;
      vtz = z3;
      vlx = x1;
      vly = y1;
      vlz = z1;
      vrx = x2;
      vry = y2;
      vrz = z2;
    } else {
      left = 2;
      vtx = x2;
      vty = y2;
      vtz = z2;
      vlx = x3;
      vly = y3;
      vlz = z3;
      vrx = x1;
      vry = y1;
      vrz = z1;
    }
  } else {
    if (y3 < y1) {
      left = 0;
      vtx = x3;
      vty = y3;
      vtz = z3;
      vlx = x1;
      vly = y1;
      vlz = z1;
      vrx = x2;
      vry = y2;
      vrz = z2;
    } else {
      left = 1;
      vtx = x1;
      vty = y1;
      vtz = z1;
      vlx = x2;
      vly = y2;
      vlz = z2;
      vrx = x3;
      vry = y3;
      vrz = z3;
    }
  }

  if (y2 <= y1) {
    if (y3 <= y1) {
      bottom = 0;
      vbx = x1;
      vby = y1;
      vbz = z1;
    } else {
      bottom = 2;
      vbx = x3;
      vby = y3;
      vbz = z3;
    }
  } else {
    if (y3 <= y2) {
      bottom = 1;
      vbx = x2;
      vby = y2;
      vbz = z2;
    } else {
      bottom = 2;
      vbx = x3;
      vby = y3;
      vbz = z3;
    }
  }

  // Compute clamped y [0ms]
  vtyc = (vty + 0xffff) >> 16;
  vbyc = (vby + 0xffff) >> 16;

  if (vtyc == vbyc) {
    return;
  }

  vlyc = (vly + 0xffff) >> 16;
  vryc = (vry + 0xffff) >> 16;

  // Setup starting points and steps [8ms]
  var xLeft;
  var xRight;
  var dxdy_left;
  var dxdy_right;

  var zLeft;
  var zRight;
  var dzdy_left;
  var dzdy_right;

  // Setup Left
  height = vly - vty;

  if (height) {
    frac = ((vtyc << 16) - vty) & 0xffff;

    // The following computations use floating point
    dxdy_left = ((vlx - vtx) * 65536) / height;
    xLeft = vtx + (dxdy_left * frac) / 65536.0;

    dzdy_left = ((vlz - vtz) * 16777216) / height;
    zLeft = (vtz << 8) + (dzdy_left * frac) / 65536.0;
  } else {
    frac = 0;
    dxdy_left = 0;
    xLeft = 0;
    dzdy_left = 0;
    zLeft = 0;
  }

  // Setup Right
  height = vry - vty;

  if (height) {
    frac = ((vtyc << 16) - vty) & 0xffff;

    // The following computations use floating point
    dxdy_right = ((vrx - vtx) * 65536) / height;
    xRight = vtx + (dxdy_right * frac) / 65536.0;

    dzdy_right = ((vrz - vtz) * 16777216) / height;
    zRight = (vtz << 8) + (dzdy_right * frac) / 65536.0;
  } else {
    frac = 0;
    dxdy_right = 0;
    xRight = 0;
    dzdy_right = 0;
    zRight = 0;
  }

  var middle = vlyc;

  if (middle > vryc) {
    middle = vryc;
  }

  // Draw top to middle section [13ms]
  var dzdx = 0;

  // Force int
  xLeft >>= 0;
  xRight >>= 0;
  dxdy_left >>= 0;
  dxdy_right >>= 0;
  zLeft >>= 0;
  zRight >>= 0;
  dzdy_left >>= 0;
  dzdy_right >>= 0;
  var c = ~~color;

  for (var y = vtyc; y < middle; y++) {
    if (y >= 0 && y < canvasHeight) {
      var x1 = (xLeft + 0xffff) >> 16;
      var x2 = (xRight + 0xffff) >> 16;
      var fracx = ((x1 << 16) - xLeft) & 0xffff;

      if (xRight - xLeft) {
        dzdx = (((zRight - zLeft) * 65536) / (xRight - xLeft)) | 0;
      }

      z = zLeft + (((dzdx * fracx) / 65536.0) | 0);

      if (x1 < 0) {
        z -= x1 * dzdx;
        x1 = 0;
      }

      if (x2 >= canvasWidth) {
        x2 = canvasWidth - 1;
      }

      var offset = 2 * (y * canvasWidth + x1);
      var x = x2 - x1;

      while (--x >= 0) {
        // If (this.zdebug)
        // c = ((z >> this.zdebug) & 0x1f) * 1057;
        var zc = zcbuffer[offset];

        if (z >> 8 >= zc >> 8 || this.disable_depth) {
          var o = c;

          if (transparency) {
            var d = zcbuffer[offset + 1];
            var dr = (d & 0xff) * transparency;
            var dg = ((d >> 8) & 0xff) * transparency;
            var db = ((d >> 16) & 0xff) * transparency;
            var da = ((d >> 24) & 0xff) * transparency;

            // Handles overflow
            var cr = (dr >> 8) + (c & 0xff);
            var cg = (dg >> 8) + ((c >> 8) & 0xff);
            var cb = (db >> 8) + ((c >> 16) & 0xff);
            var ca = (da >> 8) + ((c >> 24) & 0xff);

            if (cr > 0xff) {
              cr = 0xff;
            }

            if (cg > 0xff) {
              cg = 0xff;
            }

            if (cb > 0xff) {
              cb = 0xff;
            }

            if (ca > 0xff) {
              ca = 0xff;
            }

            o = (ca << 24) | (cb << 16) | (cg << 8) | cr;

            // No z-write
            zcbuffer[offset] = (zc & smask) | sval;
          } else {
            zcbuffer[offset] = (z & ~0xff) | (zc & smask) | sval;
          }

          zcbuffer[offset + 1] = o;
        }

        offset += 2;
        z += dzdx;
      }
    }

    xLeft += dxdy_left;
    xRight += dxdy_right;

    zLeft += dzdy_left;
    zRight += dzdy_right;
  }

  // Update starting points and steps [6ms]
  if (left == bottom) {
    // Setup_Right (vrx, vry, vryc, vbx, vby);
    height = vby - vry;

    if (height) {
      frac = ((vryc << 16) - vry) & 0xffff;

      // The following computations use floating point
      dxdy_right = ((vbx - vrx) * 65536) / height;
      xRight = vrx + (dxdy_right * frac) / 65536;

      dzdy_right = ((vbz - vrz) * 16777216) / height;
      zRight = (vrz << 8) + (dzdy_right * frac) / 65536;
    }

    xRight >>= 0;
    dxdy_right >>= 0;
    zRight >>= 0;
    dzdy_right >>= 0;
  } else {
    // Setup_Left  (vlx, vly, vlyc, vbx, vby);
    height = vby - vly;

    if (height) {
      frac = ((vlyc << 16) - vly) & 0xffff;

      // The following computations use floating point
      dxdy_left = ((vbx - vlx) * 65536) / height;
      xLeft = vlx + (dxdy_left * frac) / 65536;

      dzdy_left = ((vbz - vlz) * 16777216) / height;
      zLeft = (vlz << 8) + (dzdy_left * frac) / 65536;
    }

    xLeft >>= 0;
    dxdy_left >>= 0;
    zLeft >>= 0;
    dzdy_left >>= 0;
  }

  // Draw middle to bottom section [13ms]
  for (var y = middle; y < vbyc; y++) {
    if (y >= 0 && y < canvasHeight) {
      var x1 = (xLeft + 0xffff) >> 16;
      var x2 = (xRight + 0xffff) >> 16;

      var fracx = ((x1 << 16) - xLeft) & 0xffff;

      if (xRight - xLeft) {
        dzdx = ((zRight - zLeft) * 65536) / (xRight - xLeft);
      }

      z = zLeft + (((dzdx * fracx) / 65536.0) | 0);

      if (x1 < 0) {
        z -= x1 * dzdx;
        x1 = 0;
      }

      if (x2 >= canvasWidth) {
        x2 = canvasWidth - 1;
      }

      var offset = 2 * (y * canvasWidth + x1);
      var x = x2 - x1;

      while (--x >= 0) {
        // If (this.zdebug)
        // c = ((z >> this.zdebug) & 0x1f) * 1057;
        var zc = zcbuffer[offset];

        if (z >> 8 >= zc >> 8 || this.disable_depth) {
          var o = c;

          if (transparency) {
            var d = zcbuffer[offset + 1];
            var dr = (d & 0xff) * transparency;
            var dg = ((d >> 8) & 0xff) * transparency;
            var db = ((d >> 16) & 0xff) * transparency;
            var da = ((d >> 24) & 0xff) * transparency;

            // Handles overflow
            var cr = (dr >> 8) + (c & 0xff);
            var cg = (dg >> 8) + ((c >> 8) & 0xff);
            var cb = (db >> 8) + ((c >> 16) & 0xff);
            var ca = (da >> 8) + ((c >> 24) & 0xff);

            if (cr > 0xff) {
              cr = 0xff;
            }

            if (cg > 0xff) {
              cg = 0xff;
            }

            if (cb > 0xff) {
              cb = 0xff;
            }

            if (ca > 0xff) {
              ca = 0xff;
            }

            o = (ca << 24) | (cb << 16) | (cg << 8) | cr;

            // No z-write
            zcbuffer[offset] = (zc & smask) | sval;
          } else {
            zcbuffer[offset] = (z & ~0xff) | (zc & smask) | sval;
          }

          zcbuffer[offset + 1] = o;
        }

        offset += 2;
        z += dzdx;
      }
    }

    xLeft += dxdy_left;
    xRight += dxdy_right;

    zLeft += dzdy_left;
    zRight += dzdy_right;
  }
};

// Modified and optimized to draw in a common z and color buffer
// modified version with cutview
Sculpteo3DViewerStatic.prototype.drawTriangleScanLine3 = function (
  zcbuffer,
  canvasWidth,
  canvasHeight,
  x01,
  y01,
  z01,
  x02,
  y02,
  z02,
  x03,
  y03,
  z03,
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  x3,
  y3,
  z3,
  color,
  transparency,
  sval,
  smask,
  cutAxis,
  cutColor
) {
  // Order the vertices [2ms]

  var height, frac;
  var left, bottom;
  var left0, bottom0;

  var vtx, vty, vtyc, vtz;
  var vbx, vby, vbyc, vbz;
  var vlx, vly, vlyc, vlz;
  var vrx, vry, vryc, vrz;
  var z, x0, y0, z0;

  var vtx0, vty0, vtz0;
  var vbx0, vby0, vbz0;
  var vlx0, vly0, vlz0;
  var vrx0, vry0, vrz0;

  if (y2 < y1) {
    if (y3 < y2) {
      left = 0;
      vtx = x3;
      vty = y3;
      vtz = z3;
      vlx = x1;
      vly = y1;
      vlz = z1;
      vrx = x2;
      vry = y2;
      vrz = z2;

      vtx0 = x03;
      vty0 = y03;
      vtz0 = z03;
      vlx0 = x01;
      vly0 = y01;
      vlz0 = z01;
      vrx0 = x02;
      vry0 = y02;
      vrz0 = z02;
    } else {
      left = 2;
      vtx = x2;
      vty = y2;
      vtz = z2;
      vlx = x3;
      vly = y3;
      vlz = z3;
      vrx = x1;
      vry = y1;
      vrz = z1;

      vtx0 = x02;
      vty0 = y02;
      vtz0 = z02;
      vlx0 = x03;
      vly0 = y03;
      vlz0 = z03;
      vrx0 = x01;
      vry0 = y01;
      vrz0 = z01;
    }
  } else {
    if (y3 < y1) {
      left = 0;
      vtx = x3;
      vty = y3;
      vtz = z3;
      vlx = x1;
      vly = y1;
      vlz = z1;
      vrx = x2;
      vry = y2;
      vrz = z2;

      vtx0 = x03;
      vty0 = y03;
      vtz0 = z03;
      vlx0 = x01;
      vly0 = y01;
      vlz0 = z01;
      vrx0 = x02;
      vry0 = y02;
      vrz0 = z02;
    } else {
      left = 1;
      vtx = x1;
      vty = y1;
      vtz = z1;
      vlx = x2;
      vly = y2;
      vlz = z2;
      vrx = x3;
      vry = y3;
      vrz = z3;

      vtx0 = x01;
      vty0 = y01;
      vtz0 = z01;
      vlx0 = x02;
      vly0 = y02;
      vlz0 = z02;
      vrx0 = x03;
      vry0 = y03;
      vrz0 = z03;
    }
  }

  if (y2 <= y1) {
    if (y3 <= y1) {
      bottom = 0;
      vbx = x1;
      vby = y1;
      vbz = z1;

      vbx0 = x01;
      vby0 = y01;
      vbz0 = z01;
    } else {
      bottom = 2;
      vbx = x3;
      vby = y3;
      vbz = z3;

      vbx0 = x03;
      vby0 = y03;
      vbz0 = z03;
    }
  } else {
    if (y3 <= y2) {
      bottom = 1;
      vbx = x2;
      vby = y2;
      vbz = z2;

      vbx0 = x02;
      vby0 = y02;
      vbz0 = z02;
    } else {
      bottom = 2;
      vbx = x3;
      vby = y3;
      vbz = z3;

      vbx0 = x03;
      vby0 = y03;
      vbz0 = z03;
    }
  }

  // Compute clamped y [0ms]
  vtyc = (vty + 0xffff) >> 16;
  vbyc = (vby + 0xffff) >> 16;

  if (vtyc == vbyc) {
    return;
  }

  vlyc = (vly + 0xffff) >> 16;
  vryc = (vry + 0xffff) >> 16;

  // Setup starting points and steps [8ms]
  var xLeft;
  var xRight;
  var dxdy_left;
  var dxdy_right;

  var zLeft;
  var zRight;
  var dzdy_left;
  var dzdy_right;

  // Original point X
  var xLeft0;
  var xRight0;
  var dxdy_left0;
  var dxdy_right0;

  // Original point Y
  var yLeft0;
  var yRight0;
  var dydy_left0;
  var dydy_right0;

  // Original point Z
  var zLeft0;
  var zRight0;
  var dzdy_left0;
  var dzdy_right0;

  // Setup Left
  height = vly - vty;

  if (height) {
    frac = ((vtyc << 16) - vty) & 0xffff;
    var float_frac = frac / 65536;
    var float_height = height / 65536.0;

    // The following computations use floating point
    dxdy_left = ((vlx - vtx) * 65536) / height;
    xLeft = vtx + (dxdy_left * frac) / 65536.0;

    dzdy_left = ((vlz - vtz) * 16777216) / height;
    zLeft = (vtz << 8) + (dzdy_left * frac) / 65536.0;

    // Interp original points
    // X
    dxdy_left0 = (vlx0 - vtx0) / float_height;
    xLeft0 = vtx0 + dxdy_left0 * float_frac;

    // Y
    dydy_left0 = (vly0 - vty0) / float_height;
    yLeft0 = vty0 + dydy_left0 * float_frac;

    // Z
    dzdy_left0 = (vlz0 - vtz0) / float_height;
    zLeft0 = vtz0 + dzdy_left0 * float_frac;
  } else {
    frac = 0;
    dxdy_left = 0;
    xLeft = 0;
    dzdy_left = 0;
    zLeft = 0;

    float_frac = 0;
    dxdy_left0 = 0;
    xLeft0 = 0;
    dydy_left0 = 0;
    yLeft0 = 0;
    dzdy_left0 = 0;
    zLeft0 = 0;
  }

  // Setup Right
  height = vry - vty;

  if (height) {
    frac = ((vtyc << 16) - vty) & 0xffff;
    float_frac = frac / 65536.0;
    var float_height = height / 65536.0;

    // The following computations use floating point
    dxdy_right = ((vrx - vtx) * 65536) / height;
    xRight = vtx + (dxdy_right * frac) / 65536.0;

    dzdy_right = ((vrz - vtz) * 16777216) / height;
    zRight = (vtz << 8) + (dzdy_right * frac) / 65536.0;

    // Interp original points
    // X
    dxdy_right0 = (vrx0 - vtx0) / float_height;
    xRight0 = vtx0 + dxdy_right0 * float_frac;

    // Y
    dydy_right0 = (vry0 - vty0) / float_height;
    yRight0 = vty0 + dydy_right0 * float_frac;

    // Z
    dzdy_right0 = (vrz0 - vtz0) / float_height;
    zRight0 = vtz0 + dzdy_right0 * float_frac;
  } else {
    frac = 0;
    dxdy_right = 0;
    xRight = 0;
    dzdy_right = 0;
    zRight = 0;

    float_frac = 0;
    dxdy_right0 = 0;
    xRight0 = 0;
    dydy_right0 = 0;
    yRight0 = 0;
    dzdy_right0 = 0;
    zRight0 = 0;
  }

  var middle = vlyc;

  if (middle > vryc) {
    middle = vryc;
  }

  // Draw top to middle section [13ms]
  var dzdx = 0;

  var dxdx0 = 0;
  var dydx0 = 0;
  var dzdx0 = 0;

  // Force int
  xLeft >>= 0;
  xRight >>= 0;
  dxdy_left >>= 0;
  dxdy_right >>= 0;
  zLeft >>= 0;
  zRight >>= 0;
  dzdy_left >>= 0;
  dzdy_right >>= 0;
  var c = ~~color;

  // Tab for the dot product
  var a = [cutAxis.x, cutAxis.y, cutAxis.z];

  for (var y = vtyc; y < middle; y++) {
    if (y >= 0 && y < canvasHeight) {
      var x1 = (xLeft + 0xffff) >> 16;
      var x2 = (xRight + 0xffff) >> 16;
      var fracx = ((x1 << 16) - xLeft) & 0xffff;
      var float_fracx = fracx / 65536.0;

      if (xRight - xLeft) {
        dzdx = (((zRight - zLeft) * 65536) / (xRight - xLeft)) | 0;

        // Original points
        dxdx0 = ((xRight0 - xLeft0) * 65536.0) / (xRight - xLeft);
        dydx0 = ((yRight0 - yLeft0) * 65536.0) / (xRight - xLeft);
        dzdx0 = ((zRight0 - zLeft0) * 65536.0) / (xRight - xLeft);
      }

      z = zLeft + (((dzdx * fracx) / 65536.0) | 0);

      // Original Points
      x0 = xLeft0 + dxdx0 * float_fracx;
      y0 = yLeft0 + dydx0 * float_fracx;
      z0 = zLeft0 + dzdx0 * float_fracx;

      if (x1 < 0) {
        z -= x1 * dzdx;

        // Original Points
        x0 -= x1 * dxdx0;
        y0 -= x1 * dydx0;
        z0 -= x1 * dzdx0;
        x1 = 0;
      }

      if (x2 >= canvasWidth) {
        x2 = canvasWidth - 1;
      }

      var offset = 2 * (y * canvasWidth + x1);
      var x = x2 - x1;

      while (--x >= 0) {
        // If (this.zdebug)
        // c = ((z >> this.zdebug) & 0x1f) * 1057;
        var zc = zcbuffer[offset];

        if (
          z >> 8 >= zc >> 8 &&
          cutAxis.x * x0 + cutAxis.y * y0 + cutAxis.z * z0 > cutAxis.w
        ) {
          var o = c;

          if (transparency) {
            var d = zcbuffer[offset + 1];
            var dr = (d & 0xff) * transparency;
            var dg = ((d >> 8) & 0xff) * transparency;
            var db = ((d >> 16) & 0xff) * transparency;
            var da = ((d >> 24) & 0xff) * transparency;

            d =
              ((da >> 8) << 24) |
              ((db >> 8) << 16) |
              ((dg >> 8) << 8) |
              (dr >> 8);

            // Assumes no overflow
            o = d + c;
          }

          var b = [x0, y0, z0];
          var n = 0,
            lim = Math.min(a.length, b.length);

          // Compute distance
          // dot product between a (cutAxis) and b(Original positions)
          for (var i = 0; i < lim; i++) {
            n += a[i] * b[i];
          }

          if (Math.abs(n - cutAxis.w) < cutColor.margin) {
            o = 0xff00000ff;
          }

          zcbuffer[offset] = (z & ~0xff) | (zc & smask) | sval;
          zcbuffer[offset + 1] = o;
        }

        offset += 2;
        z += dzdx;

        // Original points
        x0 += dxdx0;
        y0 += dydx0;
        z0 += dzdx0;
      }
    }

    xLeft += dxdy_left;
    xRight += dxdy_right;

    zLeft += dzdy_left;
    zRight += dzdy_right;

    // Original points
    xLeft0 += dxdy_left0;
    xRight0 += dxdy_right0;

    yLeft0 += dydy_left0;
    yRight0 += dydy_right0;

    zLeft0 += dzdy_left0;
    zRight0 += dzdy_right0;
  }

  // Update starting points and steps [6ms]
  if (left == bottom) {
    // Setup_Right (vrx, vry, vryc, vbx, vby);
    height = vby - vry;

    if (height) {
      frac = ((vryc << 16) - vry) & 0xffff;
      float_frac = frac / 65536.0;
      var float_height = height / 65536.0;

      // The following computations use floating point
      dxdy_right = ((vbx - vrx) * 65536) / height;
      xRight = vrx + (dxdy_right * frac) / 65536;

      dzdy_right = ((vbz - vrz) * 16777216) / height;
      zRight = (vrz << 8) + (dzdy_right * frac) / 65536;

      // Interp original points
      // X
      dxdy_right0 = (vbx0 - vrx0) / float_height;
      xRight0 = vrx0 + dxdy_right0 * float_frac;

      // Y
      dydy_right0 = (vby0 - vry0) / float_height;
      yRight0 = vry0 + dydy_right0 * float_frac;

      // Z
      dzdy_right0 = (vbz0 - vrz0) / float_height;
      zRight0 = vrz0 + dzdy_right0 * float_frac;
    }

    xRight >>= 0;
    dxdy_right >>= 0;
    zRight >>= 0;
    dzdy_right >>= 0;
  } else {
    // Setup_Left  (vlx, vly, vlyc, vbx, vby);
    height = vby - vly;

    if (height) {
      frac = ((vlyc << 16) - vly) & 0xffff;
      float_frac = frac / 65536.0;
      var float_height = height / 65536.0;

      // The following computations use floating point
      dxdy_left = ((vbx - vlx) * 65536) / height;
      xLeft = vlx + (dxdy_left * frac) / 65536;

      dzdy_left = ((vbz - vlz) * 16777216) / height;
      zLeft = (vlz << 8) + (dzdy_left * frac) / 65536;

      // Interp original points
      // X
      dxdy_left0 = (vbx0 - vlx0) / float_height;
      xLeft0 = vlx0 + dxdy_left0 * float_frac;

      // Y
      dydy_left0 = (vby0 - vly0) / float_height;
      yLeft0 = vly0 + dydy_left0 * float_frac;

      // Z
      dzdy_left0 = (vbz0 - vlz0) / float_height;
      zLeft0 = vlz0 + dzdy_left0 * float_frac;
    }

    xLeft >>= 0;
    dxdy_left >>= 0;
    zLeft >>= 0;
    dzdy_left >>= 0;
  }

  // Draw middle to bottom section [13ms]
  // Tab for the dot product
  var a = [cutAxis.x, cutAxis.y, cutAxis.z];

  for (var y = middle; y < vbyc; y++) {
    if (y >= 0 && y < canvasHeight) {
      var x1 = (xLeft + 0xffff) >> 16;
      var x2 = (xRight + 0xffff) >> 16;
      var fracx = ((x1 << 16) - xLeft) & 0xffff;
      var float_fracx = frac / 65536.0;

      if (xRight - xLeft) {
        dzdx = ((zRight - zLeft) * 65536) / (xRight - xLeft);

        dxdx0 = ((xRight0 - xLeft0) * 65536.0) / (xRight - xLeft);
        dydx0 = ((yRight0 - yLeft0) * 65536.0) / (xRight - xLeft);
        dzdx0 = ((zRight0 - zLeft0) * 65536.0) / (xRight - xLeft);
      }

      z = zLeft + ((dzdx * float_fracx) | 0);

      x0 = xLeft0 + dxdx0 * float_fracx;
      y0 = yLeft0 + dydx0 * float_fracx;
      z0 = zLeft0 + dzdx0 * float_fracx;

      if (x1 < 0) {
        z -= x1 * dzdx;

        x0 -= x1 * dxdx0;
        y0 -= x1 * dydx0;
        z0 -= x1 * dzdx0;
        x1 = 0;
      }

      if (x2 >= canvasWidth) {
        x2 = canvasWidth - 1;
      }

      var offset = 2 * (y * canvasWidth + x1);
      var x = x2 - x1;

      while (--x >= 0) {
        // If (this.zdebug)
        // c = ((z >> this.zdebug) & 0x1f) * 1057;
        var zc = zcbuffer[offset];

        if (
          z >> 8 >= zc >> 8 &&
          cutAxis.x * x0 + cutAxis.y * y0 + cutAxis.z * z0 > cutAxis.w
        ) {
          var o = c;

          if (transparency) {
            var d = zcbuffer[offset + 1];
            var dr = (d & 0xff) * transparency;
            var dg = ((d >> 8) & 0xff) * transparency;
            var db = ((d >> 16) & 0xff) * transparency;
            var da = ((d >> 24) & 0xff) * transparency;

            d =
              ((da >> 8) << 24) |
              ((db >> 8) << 16) |
              ((dg >> 8) << 8) |
              (dr >> 8);

            // Assumes no overflow
            o = d + c;
          }

          var b = [x0, y0, z0];
          var n = 0,
            lim = Math.min(a.length, b.length);

          // Compute distance
          // dot product between a (cutAxis) and b(Original positions)
          for (var i = 0; i < lim; i++) {
            n += a[i] * b[i];
          }

          if (Math.abs(n - cutAxis.w) < cutColor.margin) {
            o = 0xff00000ff;
          }

          // O = c;
          zcbuffer[offset] = (z & ~0xff) | (zc & smask) | sval;
          zcbuffer[offset + 1] = o;
        }

        offset += 2;
        z += dzdx;

        x0 += dxdx0;
        y0 += dydx0;
        z0 += dzdx0;
      }
    }

    xLeft += dxdy_left;
    xRight += dxdy_right;

    zLeft += dzdy_left;
    zRight += dzdy_right;

    xLeft0 += dxdy_left0;
    xRight0 += dxdy_right0;
    yLeft0 += dydy_left0;
    yRight0 += dydy_right0;
    zLeft0 += dzdy_left0;
    zRight0 += dzdy_right0;
  }
};

// Fixed point line drawing
Sculpteo3DViewerStatic.prototype.drawCanvasLine = function (
  zcbuffer,
  canvasWidth,
  canvasHeight,
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  color
) {
  var dy = y2 - y1;
  var dx = x2 - x1;

  if (dy < 0) {
    dy = -dy;
  }

  if (dx < 0) {
    dx = -dx;
  }

  var steep = dy > dx;
  var tmp;

  if (steep) {
    // Swap x and y, we will swap them back when we draw
    tmp = x1;
    x1 = y1;
    y1 = tmp;
    tmp = x2;
    x2 = y2;
    y2 = tmp;
  }

  if (x1 > x2) {
    // Swap endpoint 1 and 2
    tmp = x1;
    x1 = x2;
    x2 = tmp;
    tmp = y1;
    y1 = y2;
    y2 = tmp;
    tmp = z1;
    z1 = z2;
    z2 = tmp;
  }

  dx = x2 - x1;
  dy = y2 - y1;
  var dz = z2 - z1;

  if (!dx) {
    return;
  }

  var gradient = ((dy * 65536) / dx) | 0;
  var gradientz = ((dz * 16777216) / dx) | 0;

  var x;
  var y = y1;
  var z = z1 << 8;
  var cw = canvasWidth << 16;
  var ch = canvasHeight << 16;

  var c = color;
  var d = false;

  if (steep) {
    for (x = x1; x < x2; x += 65536) {
      if (y >= 0 && y < cw && x >= 0 && x < ch) {
        var offset = 2 * ((x >> 16) * canvasWidth + (y >> 16));

        if (z >> 8 >= zcbuffer[offset] >> 8) {
          zcbuffer[offset] = (z & ~0xff) | 0xff;
          zcbuffer[offset + 1] = c;
          d = true;
        }
      }

      y += gradient;
      z += gradientz;
    }
  } else {
    for (x = x1; x < x2; x += 65536) {
      if (x >= 0 && x < cw && y >= 0 && y < ch) {
        var offset = 2 * ((y >> 16) * canvasWidth + (x >> 16));

        if (z >> 8 >= zcbuffer[offset] >> 8) {
          zcbuffer[offset] = (z & ~0xff) | 0xff;
          zcbuffer[offset + 1] = c;
          d = true;
        }
      }

      y += gradient;
      z += gradientz;
    }
  }
};

// Wireframe triangle drawing
Sculpteo3DViewerStatic.prototype.drawTriangleWireframe = function (
  zcbuffer,
  canvasWidth,
  canvasHeight,
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  x3,
  y3,
  z3,
  color
) {
  this.drawCanvasLine(
    zcbuffer,
    canvasWidth,
    canvasHeight,
    x1,
    y1,
    z1,
    x2,
    y2,
    z2,
    color
  );
  this.drawCanvasLine(
    zcbuffer,
    canvasWidth,
    canvasHeight,
    x2,
    y2,
    z2,
    x3,
    y3,
    z3,
    color
  );
  this.drawCanvasLine(
    zcbuffer,
    canvasWidth,
    canvasHeight,
    x3,
    y3,
    z3,
    x1,
    y1,
    z1,
    color
  );
};

Sculpteo3DViewerStatic.prototype.hideControls = function () {
  $(
    ".Sculpteo3DViewerNavigationZoom, .Sculpteo3DViewerNavigation, .Sculpteo3DViewerNavigationPan",
    this.jself
  ).hide();
  this.control_hidden = true;
};

Sculpteo3DViewerStatic.prototype.showControls = function (q) {
  this.control_hidden = false;

  if (this.experimental_canvas) {
    return;
  }

  if (this.control_timeout) {
    clearTimeout(this.control_timeout);
  }

  $(
    ".Sculpteo3DViewerNavigationZoom, .Sculpteo3DViewerNavigation, .Sculpteo3DViewerNavigationPan",
    this.jself
  ).show();
  var _jself = this.jself;

  this.control_timeout = setTimeout(function () {
    $(
      ".Sculpteo3DViewerNavigationZoom, .Sculpteo3DViewerNavigation, .Sculpteo3DViewerNavigationPan",
      _jself
    ).fadeOut(1000, function () {
      var viewer = getSculpteo3DInternalViewer($(this));

      viewer.control_hidden = true;
    });
  }, 5000);
};

Sculpteo3DViewerStatic.prototype.updateImage = function () {
  if (
    typeof this.image_pan_x == "undefined" ||
    typeof this.image_pan_y == "undefined"
  ) {
    return;
  }

  var mat = this.quatMat3(this.rotq.w, this.rotq.x, this.rotq.y, this.rotq.z);
  var cube2D = new Array();
  var zoom = this.zoom / this.image_zoom;
  var offx =
    (-this.dim / 2) * (this.image_pan_x / zoom - this.pan_x) -
    (this.width / zoom - this.width) / 2;
  var offy =
    (this.dim / 2) * (this.image_pan_y / zoom - this.pan_y) -
    (this.height / zoom - this.height) / 2;

  this.$imageDiv
    .css({ left: offx, top: offy })
    .width(this.width / zoom)
    .height(this.height / zoom)
    .find("img")
    .width(this.width / zoom)
    .height(this.height / zoom);
};

Sculpteo3DViewerStatic.prototype.updateCube = function () {
  if (!this.cube) {
    return;
  }

  var mat = this.quatMat3(this.rotq.w, this.rotq.x, this.rotq.y, this.rotq.z);
  var cube2D = new Array();

  for (var i = 0; i < 8; i++) {
    var v = [
      this.cube[3 * i + 0],
      this.cube[3 * i + 1],
      this.cube[3 * i + 2],
      0,
    ];
    var t = mat.x(v);

    cube2D[2 * i + 0] =
      this.width / 2 + (this.dim / 2) * (t[0] / this.zoom + this.pan_x);
    cube2D[2 * i + 1] =
      this.height / 2 + (this.dim / 2) * (-t[2] / this.zoom - this.pan_y);
  }

  this.drawCube(cube2D, this.width, this.height);
  this.$cube.show();
};

Sculpteo3DViewerStatic.prototype.rotate = function (q) {
  var this_rotq_w =
    q.w * this.rotq.w -
    q.x * this.rotq.x -
    q.y * this.rotq.y -
    q.z * this.rotq.z;
  var this_rotq_x =
    q.w * this.rotq.x +
    q.x * this.rotq.w +
    q.y * this.rotq.z -
    q.z * this.rotq.y;
  var this_rotq_y =
    q.w * this.rotq.y +
    q.y * this.rotq.w +
    q.z * this.rotq.x -
    q.x * this.rotq.z;
  var this_rotq_z =
    q.w * this.rotq.z +
    q.z * this.rotq.w +
    q.x * this.rotq.y -
    q.y * this.rotq.x;

  this.rotq.w = this_rotq_w;
  this.rotq.x = this_rotq_x;
  this.rotq.y = this_rotq_y;
  this.rotq.z = this_rotq_z;
};

Sculpteo3DViewerStatic.prototype.setTexture = function (img, index) {
  // Texture is not supported, just redraw the remote render
  this.setUpdate(true);
};

Sculpteo3DViewerStatic.prototype._loadModel = function (
  src,
  content,
  name,
  material
) {
  this.cancelRemote();
  this.$imageDiv.css("opacity", this.fading ? 0.3 : 0.0);
  if (typeof src == "object") {
    if (!this.scene.nodes[name]) {
      this.scene.nodes[name] = {
        material: material || "global",
        transform: Sculpteo3DViewerCommonTransform3D.identity,
      };
      this.scene.nodes[name].name = name;
    }

    this.scene.nodes[name].uuid = src.uuid;

    if (name == "model") {
      this.design_uuid = src.uuid;
      this.bbox = src.bbox.split(/,/);

      for (var k in this.bbox) {
        this.bbox[k] = parseFloat(this.bbox[k]);
      }

      this.parseBBox();
      this.postEvent("progress", "0");
      this.postEvent("progress", "100");
    }

    this.setUpdate(true);

    return;
  }

  this.loading = true;
  this.loading_bbox = true;
  var loadid = ++this.loadid;
  var _this = this;
  var ajaxreq = {
    url: src + (src.indexOf("?") >= 0 ? "&" : "?") + "viewer=static",
    cache: this.render_cache,
    context: this,
    success: function (data, status, req) {
      if (!_this.scene.nodes[name]) {
        _this.scene.nodes[name] = { material: material || "global" };
        _this.scene.nodes[name].name = name;
      }

      if (src) {
        _this.scene.nodes[name].uuid = src.split(/uuid=/)[1].split("&")[0];
      }

      if (name == "model") {
        if (_this.loadid != loadid) {
          return;
        }

        var warnings = req.getResponseHeader("X-Sculpteo-Warnings");

        _this.bbox = eval("(" + req.getResponseHeader("X-Sculpteo-BBox") + ")");
        _this.design_uuid = null;

        if (src) {
          _this.design_uuid = src.split(/uuid=/)[1];
        }

        if (warnings) {
          _this.postEvent("warnings", warnings);
        }

        _this.parseBBox();
        _this.loading = false;
        _this.loading_bbox = false;
        _this.postEvent("progress", "0");
        _this.postEvent("progress", "100");
      }

      _this.setUpdate(true);
    },

    error: function (jqXHR, textStatus, errorThrown) {
      if (_this.loadid != loadid) {
        return;
      }

      _this.loading = false;
      _this.loading_bbox = false;
      var error = jqXHR.getResponseHeader("X-Sculpteo-Message");

      if (error) {
        _this.postEvent("errorMessage", error);
      }

      // We use code 409 to indicate outdated data, retry in this case
      if (jqXHR.status == 409) {
        log("409 -> interrupted");
        _this.postEvent("interrupted", src);
      } else {
        _this.postEvent("progress", "0");
        _this.postEvent("progress", "100");
      }
    },
  };

  if (content) {
    ajaxreq.type = "POST";
    ajaxreq.data = content;
  }

  $.ajax(ajaxreq);
};

Sculpteo3DViewerStatic.prototype.drawRuler = function () {
  this.$ruler.addClass("hidden");

  var w = this.width;
  var h = this.height;
  var rule = 0.8;
  var ytext = 3.0;
  var xtext;
  var ruler_h = 6.0;
  var ruler_w;
  var unit;
  var mm_scale = this.mm_scale;
  var thou_scale = (1000.0 * mm_scale) / 25.4;
  var pow;
  var rescale;
  var scale = this.scale;
  var zoom = this.zoomx;
  var xoff = 5;
  var yoff = h - 22;

  if (this.disable3D) {
    return;
  }

  if (scale == 0.0) {
    return;
  }

  if (mm_scale == 0.0) {
    /* 1 unit = mm_scale mm */
    return;
  }

  /* Metric ruler */
  pow = Math.floor(
    Math.log((zoom * scale * rule * mm_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);

  ruler_w = (2.0 * rescale) / (scale * mm_scale);

  if (ruler_w < 0.2 * rule * zoom) {
    rescale *= 5;
    ruler_w = (2.0 * rescale) / (scale * mm_scale);
  } else if (ruler_w < 0.5 * rule * zoom) {
    rescale *= 2;
    ruler_w = (2.0 * rescale) / (scale * mm_scale);
  }

  if (rescale >= 1000.0) {
    rescale /= 1000.0;
    unit = "m";
  } else if (rescale >= 10.0) {
    rescale /= 10.0;
    unit = "cm";
  } else {
    unit = "mm";
  }

  var jtext;

  jtext = $(".Sculpteo3DViewerRuler_metric_text", this.$ruler);
  rescale = Math.floor(rescale);

  if (ruler_w < zoom && rescale > 0) {
    var text = rescale + "" + unit;
    var x, y;

    ruler_w = (ruler_w * w) / (2 * zoom);

    /* Draw the ruler */
    $(".Sculpteo3DViewerRuler_metric_start", this.$ruler).css({
      left: xoff,
      top: yoff - 6,
    });
    $(".Sculpteo3DViewerRuler_metric_length", this.$ruler).css({
      left: xoff,
      top: yoff,
      width: ruler_w,
    });
    $(".Sculpteo3DViewerRuler_metric_end", this.$ruler).css({
      left: xoff + ruler_w - 1,
      top: yoff - 6,
    });

    /* Draw the text */
    jtext.text(text);
    x = xoff + (ruler_w - jtext.width()) / 2.0;
    y = yoff - 15;
    jtext.css({ left: x, top: y });
    $(
      ".Sculpteo3DViewerRuler_metric_start, .Sculpteo3DViewerRuler_metric_length, .Sculpteo3DViewerRuler_metric_end",
      this.$ruler
    ).show();
    jtext.show();
  } else {
    $(
      ".Sculpteo3DViewerRuler_metric_start, .Sculpteo3DViewerRuler_metric_length, .Sculpteo3DViewerRuler_metric_end",
      this.$ruler
    ).hide();
    jtext.hide();
  }

  /* Imperial ruler */
  pow = Math.floor(
    Math.log((zoom * scale * rule * thou_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);

  ruler_w = (2.0 * rescale) / (scale * thou_scale);

  if (ruler_w < 0.2 * rule * zoom) {
    rescale *= 5;
    ruler_w = (2.0 * rescale) / (scale * thou_scale);
  } else if (ruler_w < 0.5 * rule * zoom) {
    rescale *= 2;
    ruler_w = (2.0 * rescale) / (scale * thou_scale);
  }

  if (rescale >= 1000.0) {
    rescale /= 1000.0;
    unit = "in";
  } else {
    unit = "mil";
  }

  var jtext;

  jtext = $(".Sculpteo3DViewerRuler_imperial_text", this.$ruler);
  rescale = Math.floor(rescale);

  if (ruler_w < zoom && rescale > 0) {
    var text = rescale + "" + unit;
    var x, y;

    ruler_w = (ruler_w * w) / (2 * zoom);

    /* Draw the ruler */
    $(".Sculpteo3DViewerRuler_imperial_start", this.$ruler).css({
      left: xoff,
      top: yoff,
    });
    $(".Sculpteo3DViewerRuler_imperial_length", this.$ruler).css({
      left: xoff,
      top: yoff,
      width: ruler_w,
    });
    $(".Sculpteo3DViewerRuler_imperial_end", this.$ruler).css({
      left: xoff + ruler_w - 1,
      top: yoff,
    });

    /* Draw the text */
    jtext.text(text);
    x = xoff + (ruler_w - jtext.width()) / 2.0;
    y = yoff - 1;
    jtext.css({ left: x, top: y });
    $(
      ".Sculpteo3DViewerRuler_imperial_start, .Sculpteo3DViewerRuler_imperial_length, .Sculpteo3DViewerRuler_imperial_end",
      this.$ruler
    ).show();
    jtext.show();
  } else {
    $(
      ".Sculpteo3DViewerRuler_imperial_start, .Sculpteo3DViewerRuler_imperial_length, .Sculpteo3DViewerRuler_imperial_end",
      this.$ruler
    ).hide();
    jtext.hide();
  }

  this.$ruler.removeClass("hidden");
};

Sculpteo3DViewerStatic.prototype.drawGrid = function () {
  $(".Sculpteo3DViewerGrid", this.jself).addClass("hidden");

  var rule = 0.8;
  var w = this.width;
  var h = this.height;
  var grid_scale;
  var unit;
  var mm_scale = this.mm_scale;
  var thou_scale = (1000.0 * mm_scale) / 25.4;
  var pow;
  var rescale;
  var scale = this.scale;
  var zoom = this.zoomx;
  var xoff = 5;
  var yoff = h - 12;

  if (this.disable3D) {
    return;
  }

  if (scale == 0.0) {
    return;
  }

  if (mm_scale == 0.0) {
    /* 1 unit = mm_scale mm */
    return;
  }

  /* Metric grid */
  pow = Math.floor(
    Math.log((zoom * scale * rule * mm_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);

  grid_scale = (2.0 * rescale) / (scale * mm_scale);

  if (grid_scale < 0.2 * rule * zoom) {
    rescale *= 5;
    grid_scale = (2.0 * rescale) / (scale * mm_scale);
  } else if (grid_scale < 0.5 * rule * zoom) {
    rescale *= 2;
    grid_scale = (2.0 * rescale) / (scale * mm_scale);
  }

  if (grid_scale < zoom && rescale > 0) {
    var x, y;

    var i, dim;

    dim = Math.ceil(zoom / grid_scale);

    /* Draw the grid */
    var html = "";

    for (var i = -dim; i <= dim; i++) {
      x = w / 2 + parseInt((i * grid_scale * w) / (2 * this.zoomx));

      if (x >= 0 && x < w) {
        html +=
          '<div class="absolute" style="top: 0px; left: ' +
          x +
          "px; width:2px; height: " +
          h +
          'px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }

      y = h / 2 + parseInt((i * grid_scale * h) / (2 * this.zoomy));

      if (y >= 0 && y < h) {
        html +=
          '<div class="absolute" style="top: ' +
          y +
          "px; left: 0px; width:" +
          w +
          'px; height: 2px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
    }

    grid_scale *= 0.1;
    dim = Math.ceil(zoom / grid_scale);

    for (var i = -dim; i <= dim; i++) {
      x = w / 2 + parseInt((i * grid_scale * w) / (2 * this.zoomx));

      if (x >= 0 && x < w) {
        html +=
          '<div class="absolute" style="top: 0px; left: ' +
          x +
          "px; width:1px; height: " +
          h +
          'px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }

      y = h / 2 + parseInt((i * grid_scale * h) / (2 * this.zoomy));

      if (y >= 0 && y < h) {
        html +=
          '<div class="absolute" style="top: ' +
          y +
          "px; left: 0px; width:" +
          w +
          'px; height: 1px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
    }

    $(".Sculpteo3DViewerGrid", this.jself).html(html);
  }

  $(".Sculpteo3DViewerGrid", this.jself).removeClass("hidden");
};

Sculpteo3DViewerStatic.prototype._remoteRender = function () {
  var id;

  if (!this.design_uuid) {
    // If (this.jself)
    // this.jself.html('');
    return;
  }

  if (this.local && this.experimental_canvas) {
    return;
  }

  if (typeof this.renderurl != "string") {
    return;
  }

  if (this.render_age == this.remote_age) {
    // Reuse the old image
    if (!this.local) {
      this.$canvas.hide();
      this.$cube.hide();

      if (!this.disable3D) {
        this.$imageDiv.show().css("opacity", this.loading ? 0.3 : 1.0);
      }
    }

    return;
  }

  if (this.rendering == this.render_age) {
    // Already rendering this age
    return;
  }

  var viewer_width = this.width;
  var viewer_height = this.height;

  var imageUrl = this.getSnapshotUrl(viewer_width, viewer_height, 0);
  var imageUrl2 = this.getSnapshotUrl(viewer_width, viewer_height, 2);

  var viewer = this;
  var jself = this.jself;

  viewer.imageurl = imageUrl;
  viewer.imageurl2 = null;

  var image_pan_x = this.pan_x;
  var image_pan_y = this.pan_y;
  var image_zoom = this.zoom;
  var _this = this;

  var age = this.render_age;

  var loader = new ImageLoader(imageUrl);

  loader.loadEvent = function (imageUrl, image) {
    if (age != viewer.render_age) {
      return;
    }

    image.width = viewer_width;
    image.height = viewer_height;
    image.id = "Sculpteo3DViewerImage";

    if ($.browser.msie) {
      image.style.filter =
        "progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true',sizingMethod='crop',src='" +
        imageUrl +
        "')";
    }

    viewer.image_pan_x = image_pan_x;
    viewer.image_pan_y = image_pan_y;
    viewer.image_zoom = image_zoom;

    viewer.$imageDiv.empty().append(image);

    if (!viewer.local) {
      viewer.$imageDiv
        .css({ opacity: this.loading ? 0.3 : 1.0, left: 0.0, top: 0.0 })
        .width(image.width)
        .height(image.height);

      if (!viewer.disable3D) {
        viewer.$imageDiv.show().css("opacity", viewer.loading ? 0.3 : 1.0);
      }

      viewer.$canvas.hide();
      viewer.$cube.hide();
    }

    if (!viewer.loading) {
      viewer.postEvent("renderstop");
    }

    if (viewer.quality > 1 && !viewer.wireframe) {
      imageUrl2 += "&quality=" + viewer.quality;

      viewer.imageurl2 = imageUrl2;
      var loader2 = new ImageLoader(imageUrl2);

      loader2.loadEvent = function (imageUrl2, image) {
        if (age != viewer.render_age) {
          return;
        }

        image.width = viewer_width;
        image.height = viewer_height;
        image.id = "Sculpteo3DViewerImage";

        if ($.browser.msie) {
          image.style.filter =
            "progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true',sizingMethod='crop',src='" +
            imageUrl2 +
            "')";
        }

        viewer.$imageDiv.empty().append(image);

        if (!viewer.local) {
          if (!viewer.disable3D) {
            viewer.$imageDiv.show().css("opacity", viewer.loading ? 0.3 : 1.0);
          }

          viewer.$cube.hide();
          viewer.$canvas.hide();
        }

        viewer.remote_age = age;
        delete viewer.rendering;

        if (!viewer.loading) {
          viewer.postEvent("hqrenderstop");
        }
      };

      loader2.errorEvent = function (imageUrl2, image) {
        if (age != viewer.render_age) {
          return;
        }

        if (!viewer.loading) {
          viewer.postEvent("hqrenderstop");
        }

        viewer.$cube.hide();

        delete viewer.rendering;
      };

      viewer.timeout2 = setTimeout(function () {
        viewer.render_state = 2;

        if (!viewer.loading) {
          viewer.postEvent("hqrenderstart");
        }

        var cookie =
          "static/" + viewer.viewer_uuid + "/" + new Date().getTime();

        Utils.setCookie("sculpteo-viewer", cookie, 0, "/");
        loader2.load();

        // Utils.delCookie("sculpteo-viewer", "/");
      }, viewer.render_timeout2);
    } else {
      viewer.remote_age = age;
      delete viewer.rendering;
    }
  };

  loader.errorEvent = function (imageUrl, image) {
    if (age != viewer.render_age) {
      return;
    }

    viewer.postEvent("renderstop");
    viewer.$cube.hide();

    delete viewer.rendering;
  };

  if (viewer.timeout) {
    clearTimeout(viewer.timeout);
  }

  if (viewer.timeout2) {
    clearTimeout(viewer.timeout2);
    viewer.timeout2 = null;
  }

  viewer.timeout = setTimeout(function () {
    viewer.postEvent("renderstart");
    var cookie = "static/" + viewer.viewer_uuid + "/" + new Date().getTime();

    // We tried set/load/del, but Chrome started the download after the cookie deletion... so don't delete the cookie
    Utils.setCookie("sculpteo-viewer", cookie, 0, "/");
    loader.load();
    viewer.rendering = age;

    // Utils.delCookie("sculpteo-viewer", "/");
  }, viewer.render_timeout);
};

Sculpteo3DViewerStatic.prototype.setUpdate = function (render_dirty, abort) {
  if (render_dirty) {
    this.render_age++;
  }

  this.update = true;

  if (this.experimental_canvas) {
    if (!this.loading) {
      this.$imageDiv.hide();
    }

    if (!this.disable3D) {
      this.$canvas.show();
    }
  } else {
    this.updateImage();
    this.updateCube();
  }

  this.cancelRemote(abort);

  if (
    this.mousedown &&
    (this.mousedown[1] || this.mousedown[3] || this.mousedown[2])
  ) {
    return;
  }

  if (
    this.experimental_canvas &&
    ((this.autorotate && !this.loading) || (this.ui && this.ui.cursorNode))
  ) {
    return;
  }

  this.remoteRender();
};

Sculpteo3DViewerStatic.prototype.createViewerFrame = function (
  jself,
  viewerId,
  options,
  width,
  height
) {
  var extra_html =
    "" +
    '<div style="zindex: 2000; top: 0px; bottom: 0px;" class="Sculpteo3DViewerStaticConsole"></div>' +
    '<span class="Sculpteo3DViewerNavigationPan-n Sculpteo3DViewerNavigationPan viewer-navigation toolbox-navigation-move-n absolute hidden" style="z-index: 1000; right: 46px; bottom: 48px"></span>' +
    '<span class="Sculpteo3DViewerNavigationPan-s Sculpteo3DViewerNavigationPan viewer-navigation toolbox-navigation-move-s absolute hidden" style="z-index: 1000; right: 46px; bottom: 12px"></span>' +
    '<span class="Sculpteo3DViewerNavigationPan-w Sculpteo3DViewerNavigationPan viewer-navigation toolbox-navigation-move-w absolute hidden" style="z-index: 1000; right: 80px; bottom: 30px"></span>' +
    '<span class="Sculpteo3DViewerNavigationPan-e Sculpteo3DViewerNavigationPan viewer-navigation toolbox-navigation-move-e absolute hidden" style="z-index: 1000; right: 12px; bottom: 30px"></span>' +
    '<span class="Sculpteo3DViewerNavigation-n Sculpteo3DViewerNavigation viewer-navigation toolbox-navigation-rotate-n absolute hidden" style="z-index: 1000; top: 0px;left: ' +
    (width / 2 - 16) +
    'px"></span>' +
    '<span class="Sculpteo3DViewerNavigation-w Sculpteo3DViewerNavigation viewer-navigation toolbox-navigation-rotate-w absolute hidden" style="z-index: 1000; left: 0px; top: ' +
    (height / 2 - 16) +
    'px;"></span>' +
    '<span class="Sculpteo3DViewerNavigation-e Sculpteo3DViewerNavigation viewer-navigation toolbox-navigation-rotate-e absolute hidden" style="z-index: 1000; right: 10px; top: ' +
    (height / 2 - 16) +
    'px;"></span>' +
    '<span class="Sculpteo3DViewerNavigation-s Sculpteo3DViewerNavigation viewer-navigation toolbox-navigation-rotate-s absolute hidden" style="z-index: 1000; left: ' +
    (width / 2 - 16) +
    'px; bottom: 10px"></span>' +
    '<span class="Sculpteo3DViewerNavigation-plus Sculpteo3DViewerNavigationZoom viewer-navigation toolbox-navigation-zoom-plus absolute hidden" style="z-index: 1000; right:10px; top: 2px;"></span>' +
    '<span class="Sculpteo3DViewerNavigation-minus Sculpteo3DViewerNavigationZoom viewer-navigation toolbox-navigation-zoom-minus absolute hidden" style="z-index: 1000; right:52px; top: 2px;"></span>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube0 absolute" id="Sculpteo3DViewerCube0-' +
    viewerId +
    '"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube1 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube2 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube3 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube4 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube5 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube6 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube7 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube8 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube9 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube10 absolute"/>' +
    '<img class="Sculpteo3DViewerCube Sculpteo3DViewerCube11 absolute"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/1up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/2up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/4up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/8up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/16up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/32up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/64up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/128up.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/1down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/2down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/4down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/8down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/16down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/32down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/64down.gif" width="0" height="0" class="hidden"/>' +
    '<img src="' +
    STATIC_URL +
    'images/line/128down.gif" width="0" height="0" class="hidden"/>';

  Sculpteo3DViewerCommon.prototype.createViewerFrame.call(
    this,
    jself,
    viewerId,
    options,
    width,
    height,
    "Sculpteo3DViewerStatic",
    extra_html
  );

  this.$cube = $(".Sculpteo3DViewerCube", jself);
};

Sculpteo3DViewerStatic.prototype.updateProjectionMatrix = function () {
  if (this.context) {
    var context = this.context;

    this.projMatrix = new Sculpteo3DViewerCommonTransform3D([
      (0.5 * context.viewportWidth) / this.zoomx,
      0.0,
      0.0,
      0.5 * context.viewportWidth,
      0.0,
      (-0.5 * context.viewportHeight) / this.zoomy,
      0.0,
      0.5 * context.viewportHeight,
      0.0,
      0.0,
      1.0 / (this.farVal - this.nearVal),
      -this.nearVal / (this.farVal - this.nearVal),
      0.0,
      0.0,
      0.0,
      1.0,
    ]);
    this.pMatrix = new Sculpteo3DViewerCommonTransform3D([
      1.0 / this.zoomx,
      0.0,
      0.0,
      0.0,
      0.0,
      1.0 / this.zoomy,
      0.0,
      0.0,
      0.0,
      0.0,
      1.0 / (this.farVal - this.nearVal),
      -this.nearVal / (this.farVal - this.nearVal),
      0.0,
      0.0,
      0.0,
      1.0,
    ]);
    this.cameraMat = new Sculpteo3DViewerCommonTransform3D();
    this.cameraPos = [0.0, 0.0, 1.0, 0.0];
    this.cameraZ = 0;
    this.zBounds = [this.nearVal, this.farVal, 0];
  }
};

// Get the depth and normal of the surface under the pixel x,y
Sculpteo3DViewerStatic.prototype.depthAndNormalAtLocation = function (x, y) {
  var context = this.context;

  var zcbuffer = this.zcbuffers[this.front];
  var W = context.viewportWidth;
  var H = context.viewportHeight;
  var x = parseInt((x / this.zoomx + 1.0) * 0.5 * (W - 1));
  var y = parseInt((-y / this.zoomy + 1.0) * 0.5 * (H - 1));

  if (x < 0) {
    x = 0;
  }

  if (x >= W) {
    x = W - 1;
  }

  if (y < 0) {
    y = 0;
  }

  if (y >= H) {
    y = H - 1;
  }

  if (zcbuffer[2 * (y * W + x)] < 0) {
    return null;
  }

  var R = 2;

  var xp = x + R;

  if (xp >= W) {
    xp = W - 1;
  }

  var yp = y + R;

  if (yp >= H) {
    yp = H - 1;
  }

  var z =
    this.nearVal +
    ((zcbuffer[2 * (y * W + x)] >> 8) / 65536) * (this.farVal - this.nearVal);

  // Approximate normal from depth derivative
  var zxp =
    this.nearVal +
    ((zcbuffer[2 * (y * W + xp)] >> 8) / 65536) * (this.farVal - this.nearVal);
  var zyp =
    this.nearVal +
    ((zcbuffer[2 * (yp * W + x)] >> 8) / 65536) * (this.farVal - this.nearVal);

  // Console.log("z = 0x" + (zcbuffer[2 * (y * W + x)] >> 15).toString(16));
  // console.log("z=" + z + " zx=" + zx + " zy=" + zy);
  var dnx = (zxp - z) / (((2 * R) / W) * this.zoomx);
  var dny = (zyp - z) / (((2 * R) / H) * this.zoomy);
  var l = Math.sqrt(dnx * dnx + dny * dny + 1.0);

  dnx /= l;
  dny /= l;
  var dnz = 1.0 / l;

  // Console.log("dn = " + dnx + "," + dny + "," + dnz);
  return { z: z, nx: -dnx, ny: dny, nz: dnz };
};

Sculpteo3DViewerStatic.prototype.nodeAtLocation = function (x, y) {
  var context = this.context;

  if (!this.experimental_canvas) {
    return null;
  }

  var zcbuffer = this.zcbuffers[this.front];
  var W = context.viewportWidth;
  var H = context.viewportHeight;
  var x = parseInt((x / this.zoomx + 1.0) * 0.5 * (W - 1));
  var y = parseInt((-y / this.zoomy + 1.0) * 0.5 * (H - 1));

  if (x < 0) {
    x = 0;
  }

  if (x >= W) {
    x = W - 1;
  }

  if (y < 0) {
    y = 0;
  }

  if (y >= H) {
    y = H - 1;
  }

  var s = zcbuffer[2 * (y * W + x)];

  if (s < 0) {
    return null;
  }

  var idx = s & 0xff;

  if (idx == 0xff) {
    return null;
  }

  if (this.scene_flat == null) {
    this._sceneUpdate();
  }

  return this.scene_flat[idx];
};

Sculpteo3DViewerStatic.prototype.drawModel = function (
  model,
  MV,
  mtype,
  wireframeColor,
  bboxColor,
  bboxOpacity,
  sval,
  smask,
  node
) {
  var context = this.context;

  // Draw
  var vn = model.vn;
  var fn = model.fn;
  var v = model.v;
  var idx = model.idx;
  var n = model.n;
  var c = model.c;
  var e = model.e;
  var gr = model.gr;
  var vt = model.vt;
  var zcbuffer = this.zcbuffers[this.front];

  // Projection matrix
  // (/!\ z-order swapped compared to GL)
  var farVal = this.farVal;
  var nearVal = this.nearVal;
  var P = this.projMatrix;

  var M = P.x(MV).toArray();
  var N = MV.transpose().inverse().toArray();

  // Transform positions and convert to fixed point [7ms]
  // TESTED: postpone computation until after face needs vertex position (and cache it), but slower
  var i = 3 * vn - 3;
  var m0 = M[0] * 65536;
  var m1 = M[1] * 65536;
  var m2 = M[2] * 65536;
  var m3 = M[3] * 65536;
  var m4 = M[4] * 65536;
  var m5 = M[5] * 65536;
  var m6 = M[6] * 65536;
  var m7 = M[7] * 65536;
  var m8 = M[8] * 65536;
  var m9 = M[9] * 65536;
  var m10 = M[10] * 65536;
  var m11 = M[11] * 65536;

  while (i >= 0) {
    var nx = v[i];
    var ny = v[i + 1];
    var nz = v[i + 2];

    vt[i + 0] = ~~(m0 * nx + m1 * ny + m2 * nz + m3) - 0x8000;
    vt[i + 1] = ~~(m4 * nx + m5 * ny + m6 * nz + m7) - 0x8000;
    vt[i + 2] = ~~(m8 * nx + m9 * ny + m10 * nz + m11);
    i -= 3;
  }

  var n0 = N[0];
  var n1 = N[1];
  var n2 = N[2];
  var n4 = N[4];
  var n5 = N[5];
  var n6 = N[6];
  var n8 = N[8];
  var n9 = N[9];
  var n10 = N[10];

  i = 3 * fn;

  var ambient = this.scene_ambient;
  var l0dx = this.light0.direction[0];
  var l0dy = this.light0.direction[1];
  var l0dz = this.light0.direction[2];
  var l0diffuse = this.light0.diffuse;
  var l1dx = this.light1.direction[0];
  var l1dy = this.light1.direction[1];
  var l1dz = this.light1.direction[2];
  var l1diffuse = this.light1.diffuse;

  var canvasWidth = context.viewportWidth;
  var canvasHeight = context.viewportHeight;

  var group = -1;

  if (typeof node.group != "undefined") {
    group = node.group;
  }

  if (this.wireframe || typeof wireframeColor != "undefined") {
    // Draw faces (wireframe mode)
    var color = 0;

    if (wireframeColor) {
      color =
        0xff000000 |
        (wireframeColor.b << 16) |
        (wireframeColor.g << 8) |
        wireframeColor.r;
    }

    // Special case for bbox
    if (e) {
      while (i > 0) {
        i -= 3;

        // [3ms]
        var i0 = idx[i];
        var x0 = vt[i0];
        var y0 = vt[i0 + 1];
        var z0 = vt[i0 + 2];
        var i1 = idx[i + 1];
        var x1 = vt[i1];
        var y1 = vt[i1 + 1];
        var z1 = vt[i1 + 2];
        var i2 = idx[i + 2];
        var x2 = vt[i2];
        var y2 = vt[i2 + 1];
        var z2 = vt[i2 + 2];
        var ev = e[i / 3];

        if (ev != 2) {
          this.drawCanvasLine(
            zcbuffer,
            canvasWidth,
            canvasHeight,
            x0,
            y0,
            z0,
            x1,
            y1,
            z1,
            color
          );
        }

        if (ev != 0) {
          this.drawCanvasLine(
            zcbuffer,
            canvasWidth,
            canvasHeight,
            x1,
            y1,
            z1,
            x2,
            y2,
            z2,
            color
          );
        }

        if (ev != 1) {
          this.drawCanvasLine(
            zcbuffer,
            canvasWidth,
            canvasHeight,
            x2,
            y2,
            z2,
            x0,
            y0,
            z0,
            color
          );
        }
      }
    }

    while (i > 0) {
      i -= 3;

      // [3ms]
      var i0 = idx[i];
      var x0 = vt[i0];
      var y0 = vt[i0 + 1];
      var z0 = vt[i0 + 2];
      var i1 = idx[i + 1];
      var x1 = vt[i1];
      var y1 = vt[i1 + 1];
      var z1 = vt[i1 + 2];
      var i2 = idx[i + 2];
      var x2 = vt[i2];
      var y2 = vt[i2 + 1];
      var z2 = vt[i2 + 2];

      this.drawTriangleWireframe(
        zcbuffer,
        canvasWidth,
        canvasHeight,
        x0,
        y0,
        z0,
        x1,
        y1,
        z1,
        x2,
        y2,
        z2,
        color
      ); // [41ms]
    }
  } else if (this.cutAxis) {
    var cutAxis = this.cutAxis;
    var cutColor = this.cutColor;
    var tmpArray = node.transform
      .transpose()
      .x([this.cutAxis.x, this.cutAxis.y, this.cutAxis.z, -this.cutAxis.w]);
    var cutAxisSupport = {
      x: tmpArray[0],
      y: tmpArray[1],
      z: tmpArray[2],
      w: -tmpArray[3],
    };

    // Draw faces
    var transparency = 0;
    var r, g, b;
    var global = false;
    var ambient_r, ambient_g, ambient_b;
    var diffuse_r, diffuse_g, diffuse_b;
    var opacity = 1.0;

    if (bboxColor) {
      global = true;
      transparency = ((1.0 - bboxOpacity) * 0xff) | 0;
      ambient_r = diffuse_r = bboxColor.r;
      ambient_g = diffuse_g = bboxColor.g;
      ambient_b = diffuse_b = bboxColor.b;
      opacity = bboxOpacity;
    } else {
      var material;

      if (mtype == "global") {
        if (this.global_material) {
          material = this.global_material;
        }
      } else if (mtype != "mesh") {
        material = this.parseMaterial(mtype);
      }

      if (material) {
        global = true;
        transparency = 0;
        ambient_r = material.ambient.color.r;
        ambient_g = material.ambient.color.g;
        ambient_b = material.ambient.color.b;
        diffuse_r = material.diffuse.color.r;
        diffuse_g = material.diffuse.color.g;
        diffuse_b = material.diffuse.color.b;
      }
    }

    // Temp
    // i=3;
    while (i > 0) {
      i -= 3;

      // Transform normals [5ms]
      var nx = n[i];
      var ny = n[i + 1];
      var nz = n[i + 2];
      var tnz = n8 * nx + n9 * ny + n10 * nz;

      // [2ms]
      var tnx = n0 * nx + n1 * ny + n2 * nz;
      var tny = n4 * nx + n5 * ny + n6 * nz;

      var l = 1.0 / Math.sqrt(tnx * tnx + tny * tny + tnz * tnz);

      // [5ms]
      var lighting = 0.0;
      var dot0 = l0dx * tnx + l0dy * tny + l0dz * tnz;
      var dot1 = l1dx * tnx + l1dy * tny + l1dz * tnz;

      if (dot0 >= 0.0) {
        lighting += l0diffuse * dot0 * l;
      }

      if (dot1 >= 0.0) {
        lighting += l1diffuse * dot1 * l;
      }

      if (global) {
        r = diffuse_r * lighting + ambient_r * ambient;
        g = diffuse_g * lighting + ambient_g * ambient;
        b = diffuse_b * lighting + ambient_b * ambient;

        if (r > 255) {
          r = 255;
        }

        if (g > 255) {
          g = 255;
        }

        if (b > 255) {
          b = 255;
        }

        r *= opacity;
        g *= opacity;
        b *= opacity;
      } else {
        // Ambient material = diffuse material
        lighting += ambient;
        r = c[i] * lighting;
        g = c[i + 1] * lighting;
        b = c[i + 2] * lighting;

        if (r > 255) {
          r = 255;
        }

        if (g > 255) {
          g = 255;
        }

        if (b > 255) {
          b = 255;
        }
      }

      var color = 0xff000000 | (b << 16) | (g << 8) | r;

      // [3ms]
      var i0, i1, i2;

      i0 = idx[i];

      if (tnz < 0) {
        i1 = idx[i + 2];
        i2 = idx[i + 1];
        color = 0xff808080;
      } else {
        i1 = idx[i + 1];
        i2 = idx[i + 2];
      }

      var x01 = v[i0];
      var y01 = v[i0 + 1];
      var z01 = v[i0 + 2];
      var x02 = v[i1];
      var y02 = v[i1 + 1];
      var z02 = v[i1 + 2];
      var x03 = v[i2];
      var y03 = v[i2 + 1];
      var z03 = v[i2 + 2];

      var x0 = vt[i0];
      var y0 = vt[i0 + 1];
      var z0 = vt[i0 + 2];
      var x1 = vt[i1];
      var y1 = vt[i1 + 1];
      var z1 = vt[i1 + 2];
      var x2 = vt[i2];
      var y2 = vt[i2 + 1];
      var z2 = vt[i2 + 2];

      // Total 33ms without triangles nor draw update
      this.drawTriangleScanLine3(
        zcbuffer,
        canvasWidth,
        canvasHeight,
        x01,
        y01,
        z01,
        x02,
        y02,
        z02,
        x03,
        y03,
        z03,
        x0,
        y0,
        z0,
        x1,
        y1,
        z1,
        x2,
        y2,
        z2,
        color,
        transparency,
        sval,
        smask,
        cutAxisSupport,
        cutColor
      ); // [41ms]
    }
  } else {
    // Draw faces
    var transparency = 0;
    var r, g, b;
    var global = false;
    var ambient_r, ambient_g, ambient_b;
    var diffuse_r, diffuse_g, diffuse_b;
    var opacity = 1.0;

    if (bboxColor) {
      global = true;
      transparency = ((1.0 - bboxOpacity) * 0xff) | 0;
      ambient_r = diffuse_r = bboxColor.r;
      ambient_g = diffuse_g = bboxColor.g;
      ambient_b = diffuse_b = bboxColor.b;
      opacity = bboxOpacity;
    } else {
      var material;

      if (mtype == "global") {
        if (this.global_material) {
          material = this.global_material;
        }
      } else if (mtype != "mesh") {
        material = this.parseMaterial(mtype);
      }

      if (material) {
        global = true;
        transparency = 0;
        ambient_r = material.ambient.color.r;
        ambient_g = material.ambient.color.g;
        ambient_b = material.ambient.color.b;
        diffuse_r = material.diffuse.color.r;
        diffuse_g = material.diffuse.color.g;
        diffuse_b = material.diffuse.color.b;
      }
    }

    while (i > 0) {
      i -= 3;

      if (group >= 0 && gr[i] != group) {
        continue;
      }

      // Transform normals [5ms]
      var nx = n[i];
      var ny = n[i + 1];
      var nz = n[i + 2];
      var tnz = n8 * nx + n9 * ny + n10 * nz;

      if (tnz <= 0.0) {
        // Cull the back faces, we are not going to draw them anyway
        continue;
      }

      // [2ms]
      var tnx = n0 * nx + n1 * ny + n2 * nz;
      var tny = n4 * nx + n5 * ny + n6 * nz;

      var l = 1.0 / Math.sqrt(tnx * tnx + tny * tny + tnz * tnz);

      // [5ms]
      var lighting = 0.0;
      var dot0 = l0dx * tnx + l0dy * tny + l0dz * tnz;
      var dot1 = l1dx * tnx + l1dy * tny + l1dz * tnz;

      if (dot0 >= 0.0) {
        lighting += l0diffuse * dot0 * l;
      }

      if (dot1 >= 0.0) {
        lighting += l1diffuse * dot1 * l;
      }

      if (global) {
        r = diffuse_r * lighting + ambient_r * ambient;
        g = diffuse_g * lighting + ambient_g * ambient;
        b = diffuse_b * lighting + ambient_b * ambient;

        if (r > 255) {
          r = 255;
        }

        if (g > 255) {
          g = 255;
        }

        if (b > 255) {
          b = 255;
        }

        r *= opacity;
        g *= opacity;
        b *= opacity;
      } else {
        // Ambient material = diffuse material
        lighting += ambient;
        r = c[i] * lighting;
        g = c[i + 1] * lighting;
        b = c[i + 2] * lighting;

        if (r > 255) {
          r = 255;
        }

        if (g > 255) {
          g = 255;
        }

        if (b > 255) {
          b = 255;
        }
      }

      var color = 0xff000000 | (b << 16) | (g << 8) | r;

      // [3ms]
      var i0 = idx[i];
      var x0 = vt[i0];
      var y0 = vt[i0 + 1];
      var z0 = vt[i0 + 2];
      var i1 = idx[i + 1];
      var x1 = vt[i1];
      var y1 = vt[i1 + 1];
      var z1 = vt[i1 + 2];
      var i2 = idx[i + 2];
      var x2 = vt[i2];
      var y2 = vt[i2 + 1];
      var z2 = vt[i2 + 2];

      // Total 33ms without triangles nor draw update
      this.drawTriangleScanLine2(
        zcbuffer,
        canvasWidth,
        canvasHeight,
        x0,
        y0,
        z0,
        x1,
        y1,
        z1,
        x2,
        y2,
        z2,
        color,
        transparency,
        sval,
        smask
      ); // [41ms]
    }
  }
};

Sculpteo3DViewerStatic.prototype.drawScene = function (deltaT) {
  var context = this.context;

  if (!this.update || this.disable3D || this.locked) {
    return;
  }

  this.update = false;

  this.frame++;

  // Glowing
  // if (this.mousedown[1])
  // this.setUpdate(false);

  // 3D cursor
  if (this.ui && this.ui.cursorNode) {
    this.setUpdate(false);
  }

  // Autorotate
  if (this.autorotate && !this.loading) {
    // Small rotation
    var angle = ((1.0 * Math.PI) / 180.0) * (deltaT / 66);
    var ca = Math.cos(angle * 0.5);
    var sa = Math.sin(angle * 0.5);
    var arot = { w: ca, x: 0, y: 0, z: sa };

    this.rotq = this.quatMul(arot, this.rotq);
    this.setUpdate(true);
  }

  this.rotq = this.quatNormalize(this.rotq);

  if (this.autorotate) {
    this.postEvent(
      "camera",
      this.rotq.w,
      this.rotq.x,
      this.rotq.y,
      this.rotq.z
    );
  }

  // Reset z+color buffer [12ms]
  // color stored in bits 0-14
  // depth stored in bits 15-30
  // sign bit indicates if pixel is present or not
  // it has faster access than the CanvasPixelArray for
  // which we update only the modified pixels
  var bgcolor = this.bgcolor24;

  this.front = 1 - this.front;
  this.back = 1 - this.back;
  var zcbuffer = this.zcbuffers[this.front];

  for (var i = 0; i < zcbuffer.length; i += 2) {
    zcbuffer[i] = -1;
    zcbuffer[i + 1] = bgcolor;
  }

  // Draw the visible instances in the scene
  if (this.scene_flat == null) {
    this._sceneUpdate();
  }

  var nodes = this.scene_flat;

  // Compute mvMatrix
  var mvMatrix = new Sculpteo3DViewerCommonTransform3D();

  mvMatrix = mvMatrix.rotate((-90.0 * Math.PI) / 180.0, 1, 0, 0);
  mvMatrix = mvMatrix.translate(
    this.pan_x * this.zoom,
    this.pan_y * this.zoom,
    0
  );
  var R = this.quatMat3(this.rotq.w, this.rotq.x, this.rotq.y, this.rotq.z);

  mvMatrix = mvMatrix.x(R);
  mvMatrix = mvMatrix.x(this.scene_transform);
  this.mvMatrix = mvMatrix;

  this.invProjCamMatrix = this.pMatrix.inverse();

  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_FLAT) {
    var selected_nodes = [];

    for (var n = 0; n < nodes.length; n++) {
      var node = nodes[n];

      if (typeof node == "undefined") {
        continue;
      }

      if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
        continue;
      }

      var model = node.model;

      if (!model) {
        continue;
      }

      if (
        node.instance.interactive & Sculpteo3DViewerCommon.INTERACTIVE_SELECT
      ) {
        selected_nodes.push(node);
      }

      var mtype = node.material || "global";

      var MV = mvMatrix.x(node.transform);

      this.drawModel(
        model,
        MV,
        mtype,
        undefined,
        undefined,
        undefined,
        n,
        0x00,
        node
      );
    }

    this.disable_depth = true;

    for (var n = 0; n < selected_nodes.length; n++) {
      var node = selected_nodes[n];
      var model = node.model;
      var mtype = node.material || "global";

      var MV = mvMatrix.x(node.transform);

      this.drawModel(
        model,
        MV,
        mtype,
        undefined,
        this.selcolor,
        this.selcolor.a / 255,
        n,
        0xff,
        node
      );
    }

    this.disable_depth = false;
  }

  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME) {
    for (var n = 0; n < nodes.length; n++) {
      var node = nodes[n];

      if (typeof node == "undefined") {
        continue;
      }

      if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME)) {
        continue;
      }

      var model = node.model;

      if (!model) {
        continue;
      }

      var MV = mvMatrix.x(node.transform);

      var color = node.instance.wireframeColor;

      if (!color) {
        color = { r: 0, g: 0, b: 0 };
      }

      this.drawModel(
        model,
        MV,
        undefined,
        color,
        undefined,
        undefined,
        0x00,
        0xff,
        node
      );
    }
  }

  // Compute and draw 3D cursor instance over the existing scene
  this.cursorInstance = this.getCursorInstance();

  if (this.cursorInstance) {
    var node = this.cursorInstance;
    var model = node.model;

    var mtype = node.material || "global";

    var MV = mvMatrix.x(node.transform);

    if (model) {
      this.drawModel(
        model,
        MV,
        mtype,
        undefined,
        undefined,
        undefined,
        0x00,
        0xff,
        node
      );
    }
  }

  // Draw the bboxes
  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_BBOX) {
    for (var n = 0; n < nodes.length; n++) {
      var node = nodes[n];

      if (typeof node == "undefined") {
        continue;
      }

      if (
        !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_BBOX) &&
        node.model
      ) {
        continue;
      }

      var model = node.proto.bboxModel;

      if (!model && node.proto.bbox) {
        // Compile bbox model on demand
        this.setBboxModel(node.proto.name, node.proto.bbox);
        model = node.proto.bboxModel;
      }

      if (!model) {
        continue;
      }

      var MV = mvMatrix.x(node.transform);

      MV = MV.x(node.proto.transform.inverse());

      var color = node.instance.bboxColor,
        opacity;

      if (!color) {
        color = { r: 0, g: 0, b: 0 };
        opacity = 0.25;
      } else {
        opacity = color.a / 255.0;
      }

      this.drawModel(
        model,
        MV,
        undefined,
        undefined,
        color,
        opacity,
        0x00,
        0xff,
        node
      );

      color = node.instance.wireframeColor;

      if (!color) {
        color = { r: 0, g: 0, b: 0 };
      }

      this.drawModel(
        model,
        MV,
        undefined,
        color,
        undefined,
        undefined,
        0x00,
        0xff,
        node
      );
    }
  }

  // Update pixels minimizing access to data/data32 which is slow
  var bbuffer = this.zcbuffers[this.back];

  // Glowing
  // alpha = (0.25 + Math.sin(((new Date()) % 3000) / 3000. * Math.PI) * 0.5) * 255;
  alpha = 255;

  var data = this.data;

  if (this.data32) {
    // Use 32-bit access for update
    var data32 = this.data32;

    // [36ms]
    for (var i = 0; i < zcbuffer.length; i += 2) {
      var zc = zcbuffer[i];

      if ((zc & bbuffer[i]) < 0) {
        continue;
      }

      if (zc >= 0) {
        var c = zcbuffer[i + 1];

        data32[i >> 1] = c;
      } else {
        data[(i << 1) + 3] = 0;
      }
    }
  } else {
    // [32ms]
    for (var i = 0; i < zcbuffer.length; i += 2) {
      var zc = zcbuffer[i];
      var b = bbuffer[i];

      if ((zc & b) < 0) {
        continue;
      }

      var j = i << 1;

      if (zc >= 0) {
        // 20ms on iPad
        if (b < 0) {
          var c = zcbuffer[i + 1];

          data[j + 0] = c & 0xff;
          data[j + 1] = (c >> 8) & 0xff;
          data[j + 2] = (c >> 16) & 0xff;
          data[j + 3] = (c >> 24) & 0xff;
        } else {
          var c = zcbuffer[i + 1];

          data[j + 0] = c & 0xff;
          data[j + 1] = (c >> 8) & 0xff;
          data[j + 2] = (c >> 16) & 0xff;
        }
      } else {
        data[j + 3] = 0;
      }
    }
  }

  // [6ms] blit the image
  context.putImageData(this.imagedata, 0, 0);

  // Fps
  var fps_date = new Date().getTime();

  if (fps_date > this.last_fps_date + 1000.0) {
    var time_delta = fps_date - this.last_fps_date;
    var frame_delta = this.frame - this.last_fps_frame;

    this.last_fps_date = fps_date;
    this.last_fps_frame = this.frame;
    log(
      "fps: " +
        (1000.0 * frame_delta) / time_delta +
        " time: " +
        time_delta / frame_delta +
        "ms"
    );
  }
};

Sculpteo3DViewerStatic.prototype.buildModel = function (mesh, done) {
  // Unroll
  var n = new Array(mesh.f.length);
  var c = new Array(mesh.f.length);
  var fn = (mesh.f.length / 3) | 0;
  var vn = (mesh.v.length / 3) | 0;
  var f = new Array(fn);
  var gr = new Array(fn);
  var v = new Array(3 * fn);
  var idx = new Array(3 * fn);

  v = mesh.v;

  for (var i = 0; i < fn; i++) {
    var r = (g = b = 255);
    var mi = mesh.face_mi[i];

    if (mi != -1 && mesh.material[mi].color) {
      r = mesh.material[mi].color.r;
      g = mesh.material[mi].color.g;
      b = mesh.material[mi].color.b;
    }

    f[i] = {
      i0: 3 * mesh.f[3 * i + 0],
      i1: 3 * mesh.f[3 * i + 1],
      i2: 3 * mesh.f[3 * i + 2],
    };
    gr[3 * i + 0] = mesh.face_gi ? mesh.face_gi[i] : -1;
    gr[3 * i + 1] = mesh.face_gi ? mesh.face_gi[i] : -1; // Unused
    gr[3 * i + 2] = mesh.face_gi ? mesh.face_gi[i] : -1; // Unused
    c[3 * i + 0] = r;
    c[3 * i + 1] = g;
    c[3 * i + 2] = b;
  }

  // Normals
  for (var i = 0; i < fn; i++) {
    var i0 = f[i].i0;
    var i1 = f[i].i1;
    var i2 = f[i].i2;
    var x0 = v[i0 + 0];
    var y0 = v[i0 + 1];
    var z0 = v[i0 + 2];
    var x1 = v[i1 + 0];
    var y1 = v[i1 + 1];
    var z1 = v[i1 + 2];
    var x2 = v[i2 + 0];
    var y2 = v[i2 + 1];
    var z2 = v[i2 + 2];

    var e0x = x1 - x0;
    var e0y = y1 - y0;
    var e0z = z1 - z0;
    var e1x = x2 - x0;
    var e1y = y2 - y0;
    var e1z = z2 - z0;

    n[3 * i + 0] = e0y * e1z - e1y * e0z;
    n[3 * i + 1] = e0z * e1x - e1z * e0x;
    n[3 * i + 2] = e0x * e1y - e1x * e0y;

    norm = Math.sqrt(
      n[3 * i + 0] * n[3 * i + 0] +
        n[3 * i + 1] * n[3 * i + 1] +
        n[3 * i + 2] * n[3 * i + 2]
    );
    n[3 * i + 0] /= norm;
    n[3 * i + 1] /= norm;
    n[3 * i + 2] /= norm;
    f[i].nx = n[3 * i + 0];
    f[i].ny = n[3 * i + 1];
    f[i].nz = n[3 * i + 2];
    idx[3 * i + 0] = i0;
    idx[3 * i + 1] = i1;
    idx[3 * i + 2] = i2;
  }

  var model = {
    v: v,
    idx: idx,
    n: n,
    c: c,
    gr: gr,
    fn: fn,
    vn: vn,
    vt: new Array(3 * vn),
  };

  if (done) {
    setTimeout(done, 0);
  }

  return { vbos: model, curves: [] };
};

Sculpteo3DViewerStatic.prototype.setBbox = function (name, bbox) {
  Sculpteo3DViewerCommon.prototype.setBbox.call(this, name, bbox);

  // Mark some edges for erasure
  this.scene.nodes[name].bboxModel.e = [
    // Edges to erase, defined by opposite vertex index
    2, // Edge 0-2
    1, // Edge 2-0
    1, // Edge 6-4
    2, // Edge 4-6
    2, // Edge 6-1
    1, // Edge 1-6
    2, // Edge 2-7
    1, // Edge 7-2
    2, // Edge 3-4
    1, // Edge 4-3
    2, // Edge 0-5
    1, // Edge 5-0
  ];
};

Sculpteo3DViewerStatic.prototype.setBackgroundColor = function (r, g, b) {
  Sculpteo3DViewerCommon.prototype.setBackgroundColor.call(this, r, g, b);

  if (this.experimental_canvas) {
    // Compute 24-bit color and reset zcbuffer background
    var bgcolor = 0xff000000 | (b << 16) | (g << 8) | r;

    this.bgcolor24 = bgcolor;

    for (var i = 0; i < this.zcbuffers[0].length; i += 2) {
      this.zcbuffers[0][i] = -1;
      this.zcbuffers[0][i + 1] = bgcolor;
      this.zcbuffers[1][i] = -1;
      this.zcbuffers[1][i + 1] = bgcolor;
      this.data[4 * i + 3] = 0; // Clear alpha
    }
  }
};

Sculpteo3DViewerStatic.prototype.setCSGMode = function (mode) {
  // Unsupported, ignore
};

Sculpteo3DViewerStatic.prototype.canvasInit = function (viewerId) {
  var context = this.context;

  if (context) {
    return;
  }

  var canvas = document.getElementById("Sculpteo3DViewerCanvas" + viewerId);

  context = canvas.getContext("2d");

  if (!context) {
    throw new Error("no 2D canvas context");

    return;
  }

  context.viewportWidth = canvas.width;
  context.viewportHeight = canvas.height;

  // Get imagedata and raw access to it for this context
  var imagedata = context.getImageData(0, 0, canvas.width, canvas.height);

  this.imagedata = imagedata;
  this.data = imagedata.data;

  if (
    window.Uint8ClampedArray &&
    this.data.constructor &&
    this.data.constructor == window.Uint8ClampedArray
  ) {
    log("using 32-bit view to clamped array");
    this.data32 = new Uint32Array(this.data.buffer);
  }

  // Initialize zcolor buffers
  this.zcbuffers = [
    new Array(2 * canvas.width * canvas.height),
    new Array(2 * canvas.width * canvas.height),
  ];
  this.front = 0;
  this.back = 1;

  for (var i = 0; i < this.zcbuffers[0].length; i += 2) {
    this.zcbuffers[0][i] = -1;
    this.zcbuffers[0][i + 1] = 0xffffffff;
    this.zcbuffers[1][i] = -1;
    this.zcbuffers[1][i + 1] = 0xffffffff;
    this.data[4 * i + 3] = 0; // Clear alpha
  }

  // Setup lighting, note that we are only able to use white light
  this.scene_ambient = 0.72;
  var light0 = {
    direction: [-5.0, 5.0, 2.0],
    diffuse: 0.5,
  };
  var light1 = {
    direction: [5.0, 5.0, 2.0],
    diffuse: 0.3,
  };

  var norm;

  norm = Math.sqrt(
    light0.direction[0] * light0.direction[0] +
      light0.direction[1] * light0.direction[1] +
      light0.direction[2] * light0.direction[2]
  );
  light0.direction[0] /= norm;
  light0.direction[1] /= norm;
  light0.direction[2] /= norm;

  norm = Math.sqrt(
    light1.direction[0] * light1.direction[0] +
      light1.direction[1] * light1.direction[1] +
      light1.direction[2] * light1.direction[2]
  );
  light1.direction[0] /= norm;
  light1.direction[1] /= norm;
  light1.direction[2] /= norm;

  this.light0 = light0;
  this.light1 = light1;

  // This.mvLoadIdentity();
  // this.mvMatrixStack = [];

  this.context = context;

  // Setup projection matrix
  this.setZoom(this.zoom);

  this.frame = 0;
  this.last_fps_date = new Date().getTime();
  this.last_fps_frame = this.frame;
};

Sculpteo3DViewerStatic.prototype.processHash = function () {
  if (
    window.location.hash.indexOf("viewer.static.experimental_canvas=false") !=
    -1
  ) {
    this.experimental_canvas = false;
  }
};

/*
Sculpteo3DViewerStatic.prototype.log = function(msg) {
	if (!this.experimental_canvas)
		return;
	$(".Sculpteo3DViewerStaticConsole", this.jself).append(msg + "<br/>");
};
*/

function Sculpteo3DViewerStatic(jself, viewerId, options) {
  var _width = parseInt(jself.width());
  var _height = parseInt(jself.height());
  /*
		If (_width > _height)
			_width = _height;
		if (_height > _width)
			_height = _width;
*/
  this.viewer_src_type = "canvas"; // The type used to access the src array of precomputed models
  this.viewer_remote_type = "canvas"; // The type reported to the server for previews
  this.local = options.local;
  this.viewer_uuid = options.uuid;
  this.envmap = options.envmap;
  this.smooth_normals = options.smooth_normals;
  this.translucency = options.translucency;
  this.quality = options.quality;
  this.remote_quality = options.remote_quality;
  this.patch_render = options.patch_render;
  this.patch_fill_type = options.patch_fill_type;
  this.patch_frequency = options.patch_frequency;
  this.patch_width = options.patch_width;
  this.patch_height = options.patch_height;
  this.width = _width;
  this.height = _height;
  this.renderurl = options.render;
  this.newSceneUrl = options.new_scene_url;
  this.dim = this.width;

  if (this.height < this.dim) {
    this.dim = this.height;
  }

  this.setMaterial(options.material);

  this.mm_scale = options.unitmm;
  this.csg_mode = Sculpteo3DViewerCommon.CSG_MODE_NONE; // Unsupported
  this.wireframe = options.wireframe;
  this.pointcloud = options.pointcloud;
  this.orientation = options.orientation;
  this.issues = options.issues;
  this.selectedfaces = options.selectedfaces;

  this.solidity = null;
  this.fading = options.fading;
  this.eventHandler = options._eventhandler;
  this.render_timeout = 500;
  this.render_timeout2 = 5000;
  this.render_cache = options.rendercache;
  this.render_age = 1;
  this.remote_age = 0;

  if (options.rendertimeout) {
    var T = options.rendertimeout.split(/,/);

    if (T.length > 0) {
      this.render_timeout = parseInt(T[0]);
    }

    if (T.length > 1) {
      this.render_timeout2 = parseInt(T[1]);
    }
  }

  this.render_width = 0; // Unlimited
  this.render_height = 0;

  if (options.rendersize) {
    var T = options.rendersize.split(/,/);

    if (T.length == 2) {
      this.render_width = parseInt(T[0]);
      this.render_height = parseInt(T[1]);
    }
  }

  if (options.transform) {
    this.setTransform(options.transform, true);
  } else {
    this.setTransform("0.9928826,0.07926025,-0.014972103,0.08762345", true);
  }

  if (options.bumpnoise) {
    this.setBumpNoise(options.bumpnoise);
  }

  this.experimental_canvas = true;

  var canvas;

  try {
    canvas = document.createElement("canvas");
    context = canvas.getContext("2d");

    if (!context) {
      throw new Error("no 2D canvas context");

      return;
    }
  } catch (e) {
    this.experimental_canvas = false;
  }

  // XXX: ugly hack for easier testing
  var viewer = this;

  $(window).bind("hashchange", function () {
    viewer.processHash();
  });

  this.processHash();

  this.createViewerFrame(jself, viewerId, options, this.width, this.height);

  this.jself = $(".Sculpteo3DViewerStatic", jself);
  $(".module-remotectrl-content .auto-rotate").hide();

  this.mouseInit();
  document.body.oncontextmenu = function (event) {
    event = event ? event : window.event;
    var target = event.target ? event.target : event.srcElement;

    if (
      target.className == "Sculpteo3DViewerCommonLayer" ||
      target.id == "Sculpteo3DViewerImage" ||
      target.id == "Sculpteo3DViewerCube0" ||
      target.id == "Sculpteo3DViewerCube1" ||
      target.id == "Sculpteo3DViewerCube2" ||
      target.id == "Sculpteo3DViewerCube3" ||
      target.id == "Sculpteo3DViewerCube4" ||
      target.id == "Sculpteo3DViewerCube5" ||
      target.id == "Sculpteo3DViewerCube6" ||
      target.id == "Sculpteo3DViewerCube7" ||
      target.id == "Sculpteo3DViewerCube8" ||
      target.id == "Sculpteo3DViewerCube9" ||
      target.id == "Sculpteo3DViewerCube10" ||
      target.id == "Sculpteo3DViewerCube11" ||
      target.id == "Sculpteo3DViewerCube12"
    ) {
      return false;
    }
  };

  var _this = this;

  if (!this.isTouchDevice() && !this.experimental_canvas) {
    $(".viewer-navigation", this.jself).hover(
      function () {
        $(this).addClass("toolbox-navigation-state-hover");
      },

      function () {
        $(this).removeClass("toolbox-navigation-state-hover");
      }
    );

    $(".Sculpteo3DViewerNavigationZoom", this.jself).mousedown(function (evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();

      if (_this.mouse_disabled) {
        return;
      }

      var direction = extractIdFromClass(
        $(this),
        "Sculpteo3DViewerNavigation-"
      );

      _this.zoom += direction == "plus" ? -0.1 : 0.1;
      _this.setZoom(_this.zoom);
      _this.setUpdate(true);
    });

    $(".Sculpteo3DViewerNavigation", this.jself).mousedown(function (evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();

      if (_this.mouse_disabled) {
        return;
      }

      var direction = extractIdFromClass(
        $(this),
        "Sculpteo3DViewerNavigation-"
      );
      var q_directions = {
        n: { x: 0.13052619222005157, y: 0, z: 0, w: -0.99144486137381038 },
        e: { x: 0, y: 0, z: 0.13052619222005157, w: 0.99144486137381038 },
        s: { x: 0.13052619222005157, y: 0, z: 0, w: 0.99144486137381038 },
        w: { x: 0, y: 0, z: 0.13052619222005157, w: -0.99144486137381038 },
      };

      _this.rotate(q_directions[direction]);
      _this.setUpdate(true);
    });

    $(".Sculpteo3DViewerNavigationPan", this.jself).mousedown(function (evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();

      if (_this.mouse_disabled) {
        return;
      }

      var direction = extractIdFromClass(
        $(this),
        "Sculpteo3DViewerNavigationPan-"
      );
      var pan_directions = {
        e: { x: 0.1, y: 0 },
        n: { x: 0, y: 0.1 },
        w: { x: -0.1, y: 0 },
        s: { x: 0, y: -0.1 },
      };

      _this.pan_x += pan_directions[direction].x;
      _this.pan_y += pan_directions[direction].y;
      _this.setUpdate(true);
    });
  }

  this.mouse_x = this.mouse_y = 0;
  this.mousedown_x = this.mousedown_y = 0;
  this.mousedown = new Array();
  this.touches = 0;

  this.zoom = this.zoom_init = options.zoom;
  this.nearVal = -2.0;
  this.farVal = 2.0;
  this.updateProjectionMatrix();

  this.setZoom(this.zoom);
  this.pan_x = 0;
  this.pan_y = 0;
  this.autorotate = options.autorotate;
  this.solidity = options.solidity;
  this.loading = false;
  this.loading_bbox = false;
  this.loadid = 0;

  if (this.experimental_canvas) {
    try {
      this.canvasInit(viewerId);

      // Restore the common loadmodel function
      this._loadModel = Sculpteo3DViewerCommon.prototype._loadModel;
    } catch (e) {
      log("canvas init error: " + e);
      this.experimental_canvas = false;
    }
  }
  if (options.bgColor) {
    this.setBackgroundColor(
      options.bgcolor[0],
      options.bgcolor[1],
      options.bgcolor[2]
    );
  }
  this.setSelectionColor(
    options.selcolor[0],
    options.selcolor[1],
    options.selcolor[2],
    options.selcolor[3]
  );

  if (options.bgImage) {
    this.setBackgroundImage(options.bgImage);
  }

  if (options.cutAxis != null) {
    this.setCutColor(
      options.cutColor[0],
      options.cutColor[1],
      options.cutColor[2],
      options.cutColor[3]
    );
    this.setCutAxis(
      options.cutAxis[0],
      options.cutAxis[1],
      options.cutAxis[2],
      options.cutAxis[3]
    );
  }

  this.scene = { nodes: {}, instances: {} };
  var rootkey = this.sceneReset();
  var modelkey = this.createNode("model");

  this._attachNode(rootkey, modelkey);

  this.scene_transform = Sculpteo3DViewerCommonTransform3D.identity;

  if (options.designUUID) {
    this.setDesignUUID(options.designUUID);
  }

  if (options.sceneTransform) {
    this.setSceneTransform(options.sceneTransform);
  }

  // UI
  this.ui = {};
  this.ui.viewer = this;
  this.ui.images = {};
  this.ui.layers = {};
  this.ui.layout = [];
  this.ui.root = this.ui.layers[this.createLayer()];
  this.setLayerFrame(this.ui.root.key, 0, 0, this.width, this.height);
  this._setRootLayer(this.ui.root);

  if (typeof options.set3d != "undefined") {
    this.setdisable3D(!options.set3d);
  }

  if (this.experimental_canvas) {
    this.startRenderLoop();
  }

  if (options.src) {
    this.loadModel(options.src);
  } else if (options.load) {
    for (var k in options.load) {
      this.loadModel(options.load[k], k);
    }
  } else {
    this.postEvent("progress", "0");
    this.postEvent("progress", "100");
  }

  this.postEvent("init");

  this.drawRuler();
  this.drawGrid();
  this.control_hidden = false;
}
